let trayaProcessingAnimation = document.getElementById('traya-processing-animation');
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};
var id = getUrlParameter('id'), f_name, C_number, C_email, user__gender, user_gender, userHairStage, caseId, pdPrice = 0, strikeFinalCartPrice = 0, hairStage;
var cohort = getUrlParameter('cohort'), factors = [];
if(id) {
  localStorage.setItem('user-gender', 'female');
  localStorage.setItem('rid', id);
}
id = localStorage.getItem('rid');
if(id == undefined) {
  id = getCookie('syntheticId');
}
(function() {
  if(!id) {
    if(window.location.pathname == '/pages/result4'){
      alert('Your recommendation is not found. Please fill the diagnosis to help us share the recommended plan.');
      document.location.href= 'https://form.traya.health/questions?cohort=1&source=ResultPage'
    }
  }else
    setotherCookie('syntheticId', id, 30, '.traya.health');
    var baseUrls = {
      DEV: 'https://api.dev.hav-g.in/',
      PROD: 'https://api.hav-g.in/'
    }
    var tokens = {
      DEV:{ 
        "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d"
      },
      PROD: { 
        "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
      }
    }
    var token = tokens.PROD;
    var baseUrl = baseUrls.PROD;
    var liveendpoint = 'https://api.hav-g.in/dgReport/female?id=';
    liveendpoint = `${baseUrl}dgReport/female?id=`
    getFemaleResult(liveendpoint, id, token);
})();

// CAPI_TRACKING_API code
function trackMetaEvent(response, eventName) {
  function getCookieValue(cookieName) {
    const cookie = document.cookie.split(';').find(c => c.trim().startsWith(cookieName + '='));
    if (!cookie) return null;
    return cookie.trim().split('=').slice(1).join('=');
  }
  
  const fbp = getCookieValue('_fbp');
  const fbc = getCookieValue('_fbc');
  const user_gender = response.gender;
  const email = response.email;
  const phone = response.phone;
  
  const capiBody = {
    eventName: eventName,
    eventTime: Date.now(),
    email: email,
    phone: phone,
    fbc: fbc,
    fbp: fbp,
    url: window.location.href,
    domain: "traya.health",
    gender: user_gender
  };
  
  const CAPI_TRACKING_API = {
    Dev: 'https://public-zxhj2.dev.hav-g.in/',
    PROD: 'https://public-jgfas325.hav-g.in/'
  };
  
  const bearerTokens = {
    DEV: { "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d" },
    PROD: { "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90" }
  };
  
  fetch(`${CAPI_TRACKING_API.PROD}tracking`, { method: 'POST', body: JSON.stringify(capiBody), headers: {
      "Content-Type": "application/json",
      ...bearerTokens.PROD
    }
  });
}

function getFemaleResult(liveendpoint, id, token) {
  document.body.style.overflow = 'hidden';

  fetch(`${liveendpoint}${id}`, {
    headers: token
  })
  .then((response) => response.json())
  .then((response) => {
    if (response.message && response.message === "Report is only for female") {
      const queryParams = window.location.search;
      window.location.href = `/pages/result4${queryParams}`;
    } else {
      let formFillDateStr = response?.User_Analysis?.case_created_date;
      let formFillDate = new Date(formFillDateStr);
      if (isNaN(formFillDate.getTime())) {
        formFillDateStr = getCookie('current_D0_date');
        formFillDate = new Date(formFillDateStr);
      }
      userHairStage = response?.User_Analysis?.hair_fall_stage?.toLowerCase();
      const caseId = response?.User_Analysis?.case_id;
      const valiedChatCase =  caseId && /^[0-7]/.test(caseId);
      const today = new Date();   
      today.setHours(0, 0, 0, 0);
      const validCase = caseId && /^[a-d]/.test(caseId);
      if (!isNaN(formFillDate.getTime())) {
        if (formFillDate < today) {
          const wrapper = document.querySelector('.whats-app-wrapper');
          if(valiedChatCase){
            wrapper.classList.remove('d-none');
            initWhatsAppTooltipAnimation();
          } else {
            const normalUserWrapper = document.querySelector('.whats-app-wrapper-normal-user');
            if (!normalUserWrapper) return;
            normalUserWrapper.classList.remove('d-none');0
          }
          const chatIconClick = document.querySelectorAll('.chat-icon-click-event');
          chatIconClick.forEach((clicked)=>{
            clicked.addEventListener('click', ()=>{
              if(valiedChatCase){
                chatIconClicked("chat_icon_clicked_female_test", caseId);
              }
            })
          })
        }
      }
      // book a call link on additionaly you'll get component 
      const hairStage = response?.User_Analysis?.hair_fall_stage?.toLowerCase();
      const customValidStage = hairStage === "medium widening" || hairStage === "advanced widening" || hairStage === "coin size patches" || hairStage === "alopecia areata";
      const onboardingVideoElement = document.querySelector(".mini-onboarding-video--container");
      if(onboardingVideoElement){
        onboardingVideoElement.classList.remove('d-none');
        document.querySelectorAll(".video-wrapper").forEach(wrapper=>{
          initVideoPlayer(wrapper);
        });
      }
      showContent(response);
      trackMetaEvent(response.User_Analysis, "Viewed Content");
      rootCause(response?.root_causes);
      if(valiedChatCase){
        initBannerPopup();  
      }

    }
  })
  .catch((error) => {
    console.error('Network Error: ', error);
  })
  .finally(() => {
    document.body.style.overflow = 'unset';
    clearCart();
  });
}

function initVideoPlayer(wrapper){
  const video = wrapper.querySelector("video");
  const source = wrapper.querySelector("source");
  const thumbnail = wrapper.querySelector(".video-thumbnail");
  const playBtn = wrapper.querySelector(".video-play-btn");
  const controls = wrapper.querySelector(".video-controls");
  const playToggle = wrapper.querySelector(".play-toggle");
  const muteToggle = wrapper.querySelector(".mute-toggle");
  const progressBar = wrapper.querySelector(".video-progress-bar");
  const progressContainer = wrapper.querySelector(".video-progress");
  let isDragging = false;
  let wasPlaying = false;
  let hideControlsTimer = null;
  function showControls(){
    controls.style.opacity = "1";
    clearTimeout(hideControlsTimer);
    hideControlsTimer = setTimeout(()=>{
      if(!video.paused && !isDragging){
        controls.style.opacity = "0";
      }
    },3000);
  }

  function startVideo(){
    if(!source.src){
      source.src = source.dataset.src;
      video.load();
    }
    video.style.display = "block";
    thumbnail.style.display = "none";
    playBtn.style.display = "none";
    controls.style.display = "flex";
    video.play();
    playToggle.innerHTML =
      `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/play.webp?v=1772691178" width="32" height="32">`;
    showControls();
  }

  function togglePlay(){
    if(video.paused){
      video.play();
      playToggle.innerHTML =
        `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/play.webp?v=1772691178" width="32" height="32">`;
      fireMiniVideoEvent("mini_onboarding_video_clicked", caseId);
    }else{
      video.pause();
      playToggle.innerHTML =
        `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/play_1.webp?v=1772691178" width="32" height="32">`;
      fireMiniVideoEvent("mini_onboarding_video_clicked", caseId);
    }
    showControls();
  }
  function seekVideo(clientX){
    const rect = progressContainer.getBoundingClientRect();
    const position = (clientX - rect.left) / rect.width;
    const clamped = Math.max(0, Math.min(1, position));
    const newTime = clamped * video.duration;
    video.currentTime = newTime;
    progressBar.style.width = clamped * 100 + "%";
    showControls();
  }
  function updateProgress(){
    if(!video.paused && !isDragging){
      const progress = (video.currentTime / video.duration) * 100;
      progressBar.style.width = progress + "%";
    }
    requestAnimationFrame(updateProgress);
  }
  /* Event Listeners */
  thumbnail.addEventListener("click", startVideo);
  playBtn.addEventListener("click", startVideo);

  video.addEventListener("click", togglePlay);
  playToggle.addEventListener("click", togglePlay);

  muteToggle.addEventListener("click", () => {
    const wasMuted = video.muted;
    video.muted = !video.muted;
    muteToggle.innerHTML = video.muted
      ? `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Frame_1_3ca2c8c9-08ab-4d12-b091-d05de7195269.webp?v=1772691138" width="20" height="19">`
      : `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Frame_a67f8797-6af8-4af0-9378-9106e26ae92e.webp?v=1772691138" width="20" height="19">`;
    if (wasMuted && !video.muted) {
      fireMiniVideoEvent("mini_onboarding_unmute_clicked", caseId);
    }
    showControls();
  });

  video.addEventListener("mousemove", showControls);
  video.addEventListener("touchstart", showControls);

  video.addEventListener("ended", () => {
    video.currentTime = 0;
    video.play();
  });

  progressContainer.addEventListener("click",(e)=>{
    seekVideo(e.clientX);
  });

  progressContainer.addEventListener("mousedown",(e)=>{
    isDragging = true;
    wasPlaying = !video.paused;
    video.pause();
    seekVideo(e.clientX);
    showControls();
  });

  document.addEventListener("mousemove",(e)=>{
    if(!isDragging) return;
    seekVideo(e.clientX);
  });

  document.addEventListener("mouseup",()=>{
    if(isDragging && wasPlaying){
      video.play();
    }
    isDragging = false;
    showControls();
  });
  progressContainer.addEventListener("touchstart",(e)=>{
    isDragging = true;
    wasPlaying = !video.paused;
    video.pause();
    seekVideo(e.touches[0].clientX);
    showControls();
  },{passive:true});
  progressContainer.addEventListener("touchmove",(e)=>{
    if(!isDragging) return;
    seekVideo(e.touches[0].clientX);
  },{passive:true});
  progressContainer.addEventListener("touchend",()=>{
    if(wasPlaying){
      video.play();
    }
    isDragging = false;
    showControls();
  });
  updateProgress();
}

function setupLanguageToggle() {
  const langBtn = document.querySelector('.language-icon-toggle');
  const arrowIcon = document.querySelector('.language-arrow-icon');
  const langDropdown = document.querySelector('.language-dropdown');
  const headerWrapper = document.querySelector(".icons-flex-container");
  const langText = document.querySelector('.language-icon');
  const headerLanguageIcon = document.getElementById("language-icon-toggle");
  const params = new URLSearchParams(window.location.search);
  const currentPage = params.get("page");
  if (headerLanguageIcon) {
    const urlParams = new URLSearchParams(window.location.search);
    const utmCampaign = urlParams.get("utm_campaign") || "";
  const page = urlParams.get("page") || "";

  const hasAllKeys =
    (utmCampaign.includes("TRFTOF") &&
      utmCampaign.includes("OnlyMHCustomers") &&
      utmCampaign.includes("CelebSayaliSanjeev")) ||
    page.includes("marathi");
    console.log(urlParams.toString(), "TEST hasAllKeys", page, hasAllKeys);
    if (hasAllKeys) {
      headerLanguageIcon.classList.remove("d-none");
    } else {
      headerLanguageIcon.classList.add("d-none");
    }
  }

  // Toggle dropdown
  langBtn?.addEventListener('click', () => {
    langDropdown?.classList.toggle('open');
    langBtn.classList.toggle('white-background');
    arrowIcon?.classList.toggle('rotate');
  });

  headerLanguageIcon?.addEventListener("click", (e) => {
    e.stopPropagation();
    document.getElementById("language-dropdown-toggle")?.classList.toggle("hidden");
    headerWrapper?.classList.toggle("hidden-dropdown");
  });
  document.querySelectorAll('.language-option').forEach(option => {
    option.addEventListener('click', function () {
      const selectedLang = this.getAttribute('lang');
      localStorage.setItem('selected_lang', selectedLang);
      if (langText) langText.textContent = selectedLang;

      document.querySelectorAll('.language-option').forEach(opt => opt.classList.remove('active'));
      this.classList.add('active');
    });
  });

  setLanguageFromStorage();
}

function setLanguageFromStorage() {
  const isFemaleResult7 = window.location.pathname.includes('female-result7');
  const selectedLang = isFemaleResult7 ? 'Marathish' : 'English';
  localStorage.setItem('selected_lang', selectedLang);
  const langText = document.querySelector('.language-icon');
  if (langText) langText.textContent = selectedLang;
  document.querySelectorAll('.language-option').forEach(opt => {
    opt.classList.remove('active');
    if (opt.getAttribute('lang') === selectedLang) {
      opt.classList.add('active');
    }
  });
}

function headerLanguageSelectorFR2(hairStage) {
  const id = new URLSearchParams(window.location.search);
  if (!id) return;

  const queryString = `?${id}`;

  const englishUrl = `/pages/female-result2${queryString}`;
  const marathiUrl = `/pages/female-result7${queryString}`;

  const options = document.querySelectorAll(".language-option");

  options.forEach(link => {
    const lang = link.getAttribute("hreflang");

    if (lang === "english") link.href = englishUrl;
    if (lang === "marathish") link.href = marathiUrl;
  });

  // Active state
  options.forEach(link => link.classList.remove("active"));
  document.querySelector('[hreflang="english"]')?.classList.add("active");

  setupLanguageToggle();
}

function rootCause (response) {
  const primaryRootCause = response?.primaryRootCause ?? [];
  const defaultRootCause = response?.defaultRootCause ?? [];
  let primaryRootCauseHtml = '';
  let primaryRootCauseContentHtml = '';
  if (primaryRootCause.length > 0) {
    primaryRootCauseHtml = `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link border active text-center" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tab" aria-controls="${primaryRootCause[0]?.title.replace(/ /g, "-")}" aria-selected="true">
        <div class="rootCauseLinkImg">
          <img src="${primaryRootCause[0]?.details?.icon}" width="32px" height="32px" loading="eager"/>
        </div>
        <p class="mt-2">${primaryRootCause[0]?.title}</p>
      </a>
    </li>`;
  }
  if (primaryRootCause.length > 0) {
    primaryRootCauseContentHtml = `<div class="tab-pane fade show active" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${primaryRootCause[0]?.details?.description?.english}</p>
    </div>`;
  }
  const defaultRootCauseHtml = defaultRootCause.map((item) => {
    return `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link border text-center" id="${item?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${item?.title.replace(/ /g, "-")}" role="tab" aria-controls="${item?.title.replace(/ /g, "-")}" aria-selected="false">
        <div class="rootCauseLinkImg">
          <img src="${item?.details?.icon}" width="32px" height="32px" loading="eager"/>
        </div>
        <p class="mt-2">${item?.title}</p>
      </a>
    </li>`;
  }).join('');
  const defaultRootCauseContentHtml = defaultRootCause.map((item) => {
    return `<div class="tab-pane fade" id="${item?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${item?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${item?.details?.description?.english}</p></div>`;
  }).join('');
  const rootCauseHtml = `<ul class="nav rootCause-nav-tabs border-0" id="myTab" role="tablist">${primaryRootCauseHtml}${defaultRootCauseHtml}</ul>
  <div class="tab-content rootCauseTabContent p-2 p-md-3 mt-3" id="myTabContent">${primaryRootCauseContentHtml}${defaultRootCauseContentHtml}</div>`;
  const rootCauseSectionWrapper = document.getElementById('rootCouseSectionWrapper');
  if (rootCauseSectionWrapper) {
    rootCauseSectionWrapper.innerHTML = rootCauseHtml;
  }
}

function showContent(response) {
  var normalPage = document.querySelectorAll('[page_type="normal"]');
  var cuticlePage = document.querySelectorAll('[page_type="cuticle"]');
  var { User_Analysis, Recommendations, stageTransition, assessmentReport, hideAssesmentImage } = response;
  var RootCauses = response.root_causes.primaryRootCause[0];
  var User_Analysis_hair_fall =  User_Analysis.hair_fall_stage;
  const newHairFallStage = User_Analysis_hair_fall;
  const hairThinningWeekText = document.querySelector('.hair_thinning_week_text-container');
  const hairThinningWeekText2 = document.querySelector('.hair_thinning_week_text-container.d-md-none');
  const removeCustomPriceSection = document.querySelector('.custom-price-section');
  
  var tillImage = document.querySelector(".tillImage img"), toImage = document.querySelector(".toImage img"), toStageWiseimg = document.querySelector(".stageWise-img"),
    assist_report = document.querySelector(".assist_report strong"), mobileDescription = document.querySelector(".mobileDescription"),
     desktopDescription = document.querySelector(".desktopDescription");
    if (hideAssesmentImage === true) {
      if (toStageWiseimg) {
        toStageWiseimg.style.cssText = "display: none;";
      }
    } else {
      if(tillImage) tillImage.setAttribute("src", stageTransition.current);
      if(toImage) toImage.setAttribute("src", stageTransition.getYouHere);
    }
  if(User_Analysis_hair_fall.toLowerCase() === "coin size patches") {
    var toImageParent = document.querySelector(".toImage"), arrowImage = document.querySelector(".stageWise-img .arrow"), stageWiseimg = document.querySelector(".stageWise-img");
    if(toImageParent) toImageParent.classList.add("d-none");
    if(arrowImage) arrowImage.classList.add("d-none");
    if(stageWiseimg) stageWiseimg.classList.add("justify-content-center");
  }
  if(assist_report) assist_report.innerHTML = User_Analysis_hair_fall;
  const defaultText = "While coin size patches cannot be cured, we offer a kit to help maintain your hair. Results may be limited due to the advanced stage of female hair loss, but we are here to support you.";
  const isCoinSizePatches = User_Analysis_hair_fall.toLowerCase() === "coin size patches";
  const displayText = isCoinSizePatches
	? defaultText
	: assessmentReport?.assessmentReport?.replace(/\n/g, "<br>");
  if (mobileDescription) mobileDescription.innerHTML = displayText;
  if (desktopDescription) desktopDescription.innerHTML = displayText;
  if (User_Analysis_hair_fall == "No widening" || User_Analysis_hair_fall == "Starting to see widening") {
    let product_card_head = document.querySelectorAll(".product-section_heading-kit");
    product_card_head.forEach((e) => {
      if (window.innerWidth < 768) {
        e.innerHTML = "Your Customised <br> Hair Treatment Kit";
      } else {
        e.textContent = "Your Customised Hair Treatment Kit";
      }
    });
  }
  
  f_name = User_Analysis.first_name; 
  C_number = User_Analysis.phone; 
  strikeFinalCartPrice =  Math.round(response.newPriceCard.updatedCartPrice); 
  setCookie('user_phone', C_number, 30)
  C_email = User_Analysis.email;
  user__gender = User_Analysis.gender;
  caseId = User_Analysis.case_id;
  localStorage.setItem('caseId', caseId);
  tagClarityCaseId(caseId);
  if(user__gender == 'F') {
    user_gender = 'Female';
  }
    productComboKit(response);
    displayStageSection(response);
    setupSomeoneLikeYou(response);
    getProductByHandle(response); 
    optionalAddOnProducts(response);
    visualFaq(response);
    // const valiedExpectationCase =  caseId && /^[0-7]/.test(caseId);
    // if(valiedExpectationCase) {
    //   document.querySelector('.timeline--container').classList.add('d-none');
    //   const timeline = getTimelineData(response);
    //   initResultsTimeline(response);
    //   renderTimeline(timeline, ".rt-timeline-wrapper");
    // } else {
    //   document.querySelector('.results-timeline-progress').classList.add('d-none');
    //   sectionMonthsExpectetion(response);
    // } 
    // document.querySelector('.timeline--container').classList.add('d-none');
    const timeline = getTimelineData(response);
    initResultsTimeline(response);
    renderTimeline(timeline, ".rt-timeline-wrapper");
    headerLanguageSelectorFR2(User_Analysis_hair_fall);
    languageSelection();
    setupTrayaForeverFaq(caseId, response);
    setupHairRoutineBanner(caseId);  
    let goal = User_Analysis.goal;
    if(goal != null && goal != 'undefined'){
      goal = goal.replace('{"',"").replace(/","/g,", ").replace(/Anti-/g,'').replace(/More/g,'').replace('"}',"")
    }else {
     goal = 'Goal';
    }
    var root_cause = `Gut:${User_Analysis.gut}, Stress:${User_Analysis.stress}`, suffering_data = User_Analysis.suffering_from_conditions,
      hair_type = User_Analysis.hair_type, Stress = User_Analysis.stress, Genetics = User_Analysis.family_genetic,
      FamilyGenetics = User_Analysis.family_genetic, EnergyLevel = User_Analysis.energy_level, Digestion = User_Analysis.acidity_bloating_gas_indigestion,
      Lowthyroid = User_Analysis.suffering_from_conditions, vitamindefeciencies = User_Analysis.vitamin_defeciencies,
      show_treatment_months = response.show_treatment_months;
    if(show_treatment_months == true){
      var _newFresult = document.querySelectorAll('.new-fresult'), __customEssential = document.querySelectorAll('.custom-essential'),
        __female_concern_months = document.querySelectorAll('.female_concern_months'), __container_will_see = document.querySelectorAll('.container.will-see');
      if(_newFresult.length != 0) {showOrHideByClass(_newFresult, 'add', 'new-fresult_pd_true');}
      if(__customEssential.length != 0) {showOrHideByClass(__customEssential, 'add', 'custom_essential_pd_true');}
      if(__female_concern_months.length != 0) {
        showOrHideByClass(__female_concern_months, 'add', 'female_months_show');
        showOrHide(__female_concern_months, 'block');
      }
      if(__container_will_see.length != 0) {showOrHide(__container_will_see, 'none');}
    }
    var user__name = document.querySelectorAll('[data-user-name]'), __data_user_name_info = document.querySelectorAll('[data-user-name-info]'),
      scalpType = document.querySelectorAll('.femleBannerTTls [scalp-type]'), __hair_concern = document.querySelectorAll('.femleBannerTTls [hair-concern]'),
      __root__cause = document.querySelectorAll('.femleBannerTTls [root-cause]'), __primary_root = document.querySelectorAll('[primary-root]'),
      __mainFactImages = document.querySelectorAll('.root_cause_iconFR .mainFactImages'), __femaleMainFactImages = document.querySelectorAll('.root_cause_iconFRs .mainFactImages'),
      __rootcause_description = document.querySelectorAll('.RootCause .rootcause_description'), __formulation = document.querySelectorAll('.formulation .formulation-text');
    if(user__name.length != 0){user__name.forEach((name) => {name.textContent = `${User_Analysis.first_name}`});}
    if(__data_user_name_info.length != 0) {__data_user_name_info.forEach((info) => {info.textContent = `${User_Analysis.first_name}'s`})}
    if(scalpType.length != 0) {scalpType.forEach((scalp) => {scalp.textContent = `${User_Analysis.hair_type}`})}
    if(__hair_concern.length != 0) {__hair_concern.forEach((concern) => {concern.textContent = `${goal}`})}
    if(__root__cause.length != 0) {__root__cause.forEach((cause) => {cause.textContent = `${factors[0]}`})}
    if(__primary_root.length != 0) {__primary_root.forEach((root) => {root.textContent = `${factors[0]}`})}
    if(__mainFactImages.length != 0) {showOrHide(__mainFactImages, 'none');}
  
    var ATC_frp = document.querySelectorAll('#add-to-cart-result-page-frp'), stickyATC_frp = document.querySelectorAll('.sticky-btn #add-to-cart-result-page-frp'),
      ATC_rp = document.querySelectorAll('.add-to-cart-result-page');
    if(ATC_frp.length != 0) {
      ATC_frp.forEach((rp) => {
        rp.setAttribute('user-mobile', User_Analysis.phone);
        rp.setAttribute('user-email', User_Analysis.email);
      });
    }
    if(stickyATC_frp.length != 0) {
      stickyATC_frp.forEach((rp) => {
        rp.setAttribute('user-mobile', User_Analysis.phone);
        rp.setAttribute('user-email', User_Analysis.email);
      });
    }
    if(ATC_rp.length != 0) {
      ATC_rp.forEach((rp) => {
        rp.setAttribute('user-mobile', User_Analysis.phone);
        rp.setAttribute('user-email', User_Analysis.email);
      });
    }
  
  let buyButtonElement = document.querySelectorAll('#add-to-cart-result-page-frp');
  buyButtonElement.forEach((eachBtn) => {
    eachBtn.addEventListener('click', () => {
       eachBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_3.svg?v=1741241123" class="loader-icon" alt="Loading...">`;
       eachBtn.classList.add('loader-added')
       eachBtn.disabled = true;
       trackMetaEvent(response.User_Analysis, "Expand Benefits");
       window.umami.track('buy_now_click', {
        syntheticId: window.location.search.substring(1).split('=')[1] || "default-id",
        fingerprintId: window.__deviceId
      });
      setTimeout(() => {
        if (window.appliedReferralCode) {
          window.location.href = `/checkout?discount=${window.appliedReferralCode}`;
        } else {
          window.location.href = '/checkout';
        }
      }, 100);
      setTimeout(() => {
         removeLoader();
      }, 2000);
    });
  });

  const cards = document.querySelectorAll("[data-card]");
  cards.forEach(card => {
    const video = card.querySelector("[data-video]");
    const videoURL = video.dataset.videoUrl;
    const playBtn = card.querySelector("[data-play]");
    const videoTitle = card.querySelector(".real-story-thumb")?.getAttribute("alt") || "Real Story Video";
    playBtn.addEventListener("click", () => {
      fireVideoEvent("Video_thumbnail_clicked", caseId, videoURL, videoTitle);
    });
  });

  // chat flotie js 
  const fabWrapper = document.querySelector('.whats-app-wrapper-normal-user');
  const fabButton = document.getElementById('fabMainButton');
  const actionItems = document.querySelectorAll('.fab-action-item');

  if (!fabWrapper || !fabButton) return;

  let isExpanded = false;

  // Toggle FAB (open / close via main button)
  fabButton.addEventListener('click', function (e) {
    e.stopPropagation();

    fabWrapper.classList.toggle('expanded');
    isExpanded = fabWrapper.classList.contains('expanded');

    if (isExpanded) {
      chatIconClicked("web_floating_icon_clicked", caseId);
    } else {
      chatIconClicked("floating_icon_closed", caseId);
    }
  });

  // Close when clicking outside
  document.addEventListener('click', function (e) {
    if (isExpanded && !fabWrapper.contains(e.target)) {
      fabWrapper.classList.remove('expanded');
      isExpanded = false;
      chatIconClicked("floating_icon_closed", caseId);
    }
  });

// CTA clicks (Chat / Book a Call)
actionItems.forEach(item => {
  item.addEventListener('click', function (e) {
    e.stopPropagation();

    let ctaClicked = '';

    if (item.classList.contains('whatsapp-btn')) {
      ctaClicked = 'chat with us';
      // Let the native <a href> handle WhatsApp — don't preventDefault
    } else if (item.classList.contains('book-call-btn')) {
      ctaClicked = 'book a call';
      e.preventDefault(); // stop the broken native href on this button only

      const safeCaseId = caseId || localStorage.getItem('caseId');
      const redirectUrl = `https://form.traya.health/pages/reschedule-slot/${safeCaseId}?femaleResultPage=true`;

      window.open(redirectUrl, '_blank', 'noopener,noreferrer');
    }

    fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
      method: "POST",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
      },
      body: JSON.stringify({
        eventName: "floating_icon_cta_clicked",
        eventAttributes: {
          generalAttributes: {
            platform: "web_shopify",
            domain: "traya.health",
            syntheticId: window.location.search.substring(1).split('=')[1] || "default-id",
            cta_clicked: ctaClicked
          }
        },
        caseId: caseId
      })
    });
  });
});

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isExpanded) {
      fabWrapper.classList.remove('expanded');
      isExpanded = false;
      chatIconClicked("floating_icon_closed", caseId);
    }
  });
}

function chatIconClicked(eventName, caseID) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}

function fireTrayaForeverEvent(eventName, caseID, syntheticID) {
  fetch('https://public-jgfas325.hav-g.in/eventMoengageWeb', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90'
    },
    body: JSON.stringify({
      eventName: eventName,
      eventAttributes: {
        generalAttributes: {
          platform: 'web_shopify',
          domain: 'traya.health',
          syntheticId: syntheticID
        }
      },
      caseId: caseID
    })
  });
}

function displayStageSection(response) {
  const stageImages = {
    "hair thinning": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_c2a537bc-4919-4b83-a12f-3767cb8d1b25.webp?v=1756899713",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_3bca6c41-ac7a-4ec8-9a57-43b2dd498985.webp?v=1756899713",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_7d151296-1377-4a5c-b218-da4db4a72c4c.webp?v=1756899713"
        
      ],
      customerName: "Sakshi"
    },
    "widening" : {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_906439c7-0777-4323-a6fb-54e2226571be.webp?v=1756899831",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_385b4e21-187d-4c80-bf27-4de49bb8b384.webp?v=1756899831",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_1f4670c5-e3be-47a5-8890-fb50592e1dac.webp?v=1756899831"
      ],
      customerName: "Poonam"
    },
    "advanced widening": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_2_a6008d93-33ea-4539-a4f3-0a31b1e81546.webp?v=1756988341",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_2.webp?v=1756988341",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_1_5371c479-d809-4fc5-bd81-c1d1e6535b23.webp?v=1756988341"
      ],
      customerName: "Pratima"
    },
    "side thinning": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_1_0f684d2e-9d4b-4fc8-9c86-839c3d112433.webp?v=1756900221",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_1_a54b4d61-d7b0-449b-80a5-8b8c7aeb624c.webp?v=1756900221",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_1_0c8e0bca-7f44-40be-a1b5-5304dafe1c46.webp?v=1756900220"
      ],
      customerName: "Anjali"
    },
    "coin size patches": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_1_6041ce02-9314-4e64-8aff-668a3eba433a.webp?v=1756982697",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_1_dd3429b7-2edc-4dd8-8d98-bd019141c6c0.webp?v=1756982697",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_4aeb8cec-257c-454d-8434-548a24b29258.webp?v=1756900342"
      ],
      customerName: "Supriya"
    },
    "alopecia areata": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_1_6041ce02-9314-4e64-8aff-668a3eba433a.webp?v=1756982697",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_1_dd3429b7-2edc-4dd8-8d98-bd019141c6c0.webp?v=1756982697",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_4aeb8cec-257c-454d-8434-548a24b29258.webp?v=1756900342"
      ],
      customerName: "Supriya"
    }
  };

  const userStageRaw = response.User_Analysis.hair_fall_stage;
  const userStage = userStageRaw?.toLowerCase();
  console.log("User stage from response:", userStage);
  let stageData = null;
  for (const stageKey in stageImages) {
    if (stageKey.toLowerCase() === userStage) {
        stageData = stageImages[stageKey];
        break;
    }
  }
  console.log("User stage from response:", userStage);

  const stageContainer = document.getElementById("stageContainer");
  stageContainer.innerHTML = ""; 
  
  if (stageData && stageData.images.length > 0) {
    // ── OPTIMIZATION: build entire stageContainer in a DocumentFragment (1 reflow) ──
    const fragment = document.createDocumentFragment();

    const p1 = document.createElement("p");
    p1.textContent = "Here's someone like you";
    p1.className = "custome-stage-heading";
    fragment.appendChild(p1);

    const p2 = document.createElement("p");
    p2.textContent = `${stageData.customerName} was unsure, but she stayed consistent`;
    p2.className = "custome-stage-subheading";
    fragment.appendChild(p2);

    const imageWrapper = document.createElement("div");
    imageWrapper.className = "stage-image-wrapper";

    let arrowSvgImage = `<svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
        <path d="M0.902344 16C0.902344 7.16344 8.06579 0 16.9023 0C25.7389 0 32.9023 7.16344 32.9023 16C32.9023 24.8366 25.7389 32 16.9023 32C8.06579 32 0.902344 24.8366 0.902344 16Z" fill="#EDD2CE"/>
        <path d="M13.7021 22.3984L20.1021 15.9984L13.7021 9.59844" stroke="#262626" stroke-width="1.6"/>
      </svg>`;

    stageData.images.forEach((imgUrl, index) => {
      const img = document.createElement("img");
      img.src = imgUrl;
      img.alt = userStage;
      img.className = "scrollable-stage-image";
      img.loading = "lazy";
      imageWrapper.appendChild(img);
    
      if (index < stageData.images.length - 1) {
        const arrowWrapper = document.createElement("div");
        arrowWrapper.innerHTML = arrowSvgImage;
        arrowWrapper.className = "stage-arrow";
        imageWrapper.appendChild(arrowWrapper);
      }
    });

    fragment.appendChild(imageWrapper);
    stageContainer.appendChild(fragment);
    // ── END OPTIMIZATION ──
  }
}

function removeLoader() {
  let buyButtonLoader = document.querySelectorAll('#add-to-cart-result-page-frp');
  buyButtonLoader.forEach((eachBtn) => {
    eachBtn.innerHTML = "Buy Now";
    eachBtn.classList.remove('loader-added')
    eachBtn.disabled = false;
 });
}
  
function showOrHide(partition, state) {
  partition.forEach((part) => {
    part.style.display = `${state}`;
  })
}

function showOrHideByClass(partition, work, state) {
  partition.forEach((part) => {
    if(work == 'add') {part.classList.add(state)}
    if(work == 'remove') {part.classList.remove(state)}
  })
}

var prices = 0, variantsIDs = [];
function getProductByHandle(response) {
  let resultTotalPrice = document.querySelectorAll('.total-price');
  let strikeTotalPrice = document.querySelectorAll('.strike-cart-total-price');
  const strikeFinalCartPrice = Math.round(response.newPriceCard.updatedCartPrice);
  const finalCartPrice = Math.round(response.cart_price); 
  
  if (strikeTotalPrice.length !== 0) {
    strikeTotalPrice.forEach((price) => {
      price.innerHTML = `₹ ${finalCartPrice + 999}`;
    });
  }
  if(resultTotalPrice.length != 0) {
    resultTotalPrice.forEach((price) => {
      price.innerHTML = `₹ ${finalCartPrice}`
    })
  }
  let combinedCartValue = document.querySelector('.combined-cart-price-mrp');
  if(combinedCartValue){
    const combinedCartPrice = `₹ ${finalCartPrice + 999}`;
    combinedCartValue.innerHTML = `${combinedCartPrice}`;
  }
  let pricePerDay = document.querySelector('.recommend-price-perday price-perday');
  if(pricePerDay){
    const perDayPriceValue = Math.round(finalCartPrice / 30);
    pricePerDay.innerText = `${perDayPriceValue}`;
  }
  applyOneMonthDiscount(response);
}

function setupHairRoutineBanner(caseId) {
  const hairRoutineBanner = document.querySelector('.hair-routine-banner');
  if (!hairRoutineBanner) return;
  const validChatCase = caseId && /^[5-9]/.test(caseId);
  if (!validChatCase) return;
  hairRoutineBanner.classList.remove('d-none');
  hairRoutineBanner.addEventListener('click', () => {
    const syntheticId =
      window.location.search.substring(1).split('=')[1] || "default-id";
    chatIconClicked("web_rp_how_to_use_click", caseId, syntheticId);
    setTimeout(() => {
      const routineUrl = `https://form.traya.health/how-to-use/${caseId}`;
      window.location.href = routineUrl;
    }, 500);
  });
}

// ===== Future Kit Routine Switcher =====
function FutureKitRoutine(maxMonths) {

  const section = document.querySelector('[id^="future-kit-routine-"]');
  if (!section) return;

  const deskImg = section.querySelector('.future-kit-img--desk');
  const mobImg  = section.querySelector('.future-kit-img--mob');

  const FUTURE_KIT_IMAGES = {
    5: {
      desk: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/5months_desktop.webp?v=1772018557',
      mob:  'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/5months_mobile.webp?v=1772018531'
    },
    8: {
      desk: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/8months_desktop.webp?v=1772018589',
      mob:  'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/8months_mobile.webp?v=1772018618'
    },
    12: {
      desk: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/12months_desktop.webp?v=1772018633',
      mob:  'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/12months_mobile.webp?v=1772018603'
    }
  };

  if (!maxMonths || !FUTURE_KIT_IMAGES[maxMonths]) {
    console.warn('FutureKitRoutine: invalid maxMonths', maxMonths);
    return;
  }

  deskImg.src = FUTURE_KIT_IMAGES[maxMonths].desk;
  mobImg.src  = FUTURE_KIT_IMAGES[maxMonths].mob;
}
function applyOneMonthDiscount(response) {
  const discountsData = response?.discounts;
  if (!discountsData) return;
  if (!discountsData.discountValidityByPlan?._1Month) return;
  const discountObj = discountsData.discount?.[0];
  if (!discountObj) return;
  const { code, value, validCartValue } = discountObj;
  if (!code || !value || !validCartValue) return;
  const cartTotal = Math.round(response.cart_price);
  if (cartTotal < validCartValue) return;
  let discountAmount = 0;
  if (discountObj.type === 'percentage') {
    discountAmount = Math.round((cartTotal * value) / 100);
  } else {
    discountAmount = value;
  }
  const discountedTotal = Math.max(cartTotal - discountAmount, 0);
  const discountStrikeElement = Math.round(response.newPriceCard.updatedCartPrice);
  const originalStrikePrice = discountStrikeElement + 500;
  console.log(originalStrikePrice[1])
  document.querySelectorAll('.strike-cart-total-price').forEach(el => {
    el.innerHTML = `₹ ${updatedStrikePrice}`;
  });

  document.querySelectorAll('.total-price').forEach(el => {
    el.innerHTML = `₹ ${discountedTotal}`;
  });
  document.querySelectorAll('.refferal-discount-applied').forEach(el => {
    el.classList.remove('d-none');
  });
  window.appliedReferralCode = code;
}

function getIngredientData(variantId) {
  return popOneLinerData.find(item => item.productVariantId === variantId);
}

function renderProductCard(product, usageOneLiner = '') {
  const valiedChatCase = caseId && /^[0-7]/.test(caseId);
  const desktopVisibilityClass = valiedChatCase ? 'd-none d-md-flex' : 'd-block'; 
  const mobileProductData = popOneLinerData.find(
    item => String(item.productVariantId) === String(product.product_id)
  );
  const FREE_PRODUCT_IDS = ["45277154377906", "47084348309682"];
  const oneLinerText = product.oneLiner || product.one_liner || product.oneliner || mobileProductData?.oneliner || '';
  const mobileProductImage = mobileProductData?.productImage || product.image_url?.singleImage || product.image_url;
  const ingredientData = getIngredientData(product.product_id);
  let ingredientsHTML = '';
  if (ingredientData && ingredientData.ingredientName) {
    const names = ingredientData.ingredientName.split('|');
    const images = ingredientData.ingredientImage.split('|');

    ingredientsHTML = names.map((name, i) => `
      <div class="ingredient-item">
        <div class="ingredient-img">
          <img src="${images[i].trim()}" loading="lazy"/>
        </div>
        <p>${name.trim()}</p>
      </div>
    `).join('');
  }
  document.body.classList.add('cc-redesign');
  const desktopHTML = `
  <!-- DESKTOP -->
  <div class="reco-pro reco-product-combo remove-cart-experiment">
    <div class="box-separator-line">
      <div class="hairthinning-combo-kit-wrapper">
        <div class="hairthinning-combo-kit-container">
          <div class="p-image-container">
            <img src="${product.image_url.singleImage}" alt="${product.image_url.singleImage}"  width="100px" height="100px" loading="lazy" class="p-image"/>
          </div>    
          
          <div class="prod-content-wrapper">
            <div class="p-content-container">
              <div class="p-title-tag-container">
                <h2 class="p-title cc-card__title">${product.name}</h2>
              </div>
              <p class="liner-text cc-card__oneliner">${product.oneLiner}</p>
            </div>
          </div>
          <div class="remove-icon-container">
            <div class="arrow-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
                <path d="M6.5306 7.03062L1.5306 12.0306C1.3897 12.1715 1.19861 12.2507 0.999348 12.2507C0.80009 12.2507 0.608994 12.1715 0.468098 12.0306C0.327201 11.8897 0.248047 11.6986 0.248047 11.4994C0.248047 11.3001 0.327201 11.109 0.468098 10.9681L4.93747 6.5L0.469348 2.03062C0.399583 1.96086 0.344243 1.87804 0.306486 1.78689C0.26873 1.69573 0.249297 1.59804 0.249297 1.49937C0.249297 1.40071 0.26873 1.30302 0.306486 1.21186C0.344243 1.12071 0.399583 1.03789 0.469348 0.968125C0.539113 0.89836 0.621936 0.843019 0.713088 0.805263C0.80424 0.767507 0.901936 0.748074 1.0006 0.748074C1.09926 0.748074 1.19696 0.767507 1.28811 0.805263C1.37926 0.843019 1.46208 0.89836 1.53185 0.968125L6.53185 5.96812C6.60169 6.03788 6.65707 6.12074 6.69481 6.21195C6.73256 6.30316 6.75193 6.40092 6.75181 6.49963C6.7517 6.59834 6.7321 6.69606 6.69414 6.78718C6.65617 6.8783 6.6006 6.96103 6.5306 7.03062Z" fill="black"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>`;

  let mobileHTML = '';
  if (valiedChatCase) {
    mobileHTML = `
    <!-- MOBILE EXPERIMENT -->
    <div class="mobile-product-card d-flex d-md-none">
      <div class="mobile-product-image--wrapper">
        ${product.product_id != "45277154377906" ?
          `<div class="product-remove-btn" data-variant-id="${product.product_id}" data-product-name="${product.name}" data-product-image="${product.image_url.singleImage}">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M2.5 5.00033H17.5M15.8333 5.00033V16.667C15.8333 17.5003 15 18.3337 14.1667 18.3337H5.83333C5 18.3337 4.16667 17.5003 4.16667 16.667V5.00033M6.66667 5.00033V3.33366C6.66667 2.50033 7.5 1.66699 8.33333 1.66699H11.6667C12.5 1.66699 13.3333 2.50033 13.3333 3.33366V5.00033" stroke="#262626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>`
        : ''}
        <div class="mobile-product-image">
          <img src="${mobileProductImage}" loading="lazy"/>
        </div>
      </div>
      <div class="mobile-product-content--wrapper">
        <h3 class="result-product-title">${product.name}</h3>
        <div class="mobile-price">
          ₹${Math.floor(product.price)}
        </div>
        <p class="mobile-oneliner">
          ${oneLinerText}
        </p>
        <hr>
        ${ingredientsHTML ? `
        <div class="mobile-ingredients">
          <p class="ingredients-title">Key Ingredients</p>
          <div class="ingredients-flex">
            ${ingredientsHTML}
          </div>
        </div>
        ` : ''}
        <div class="mobile-more-details">
          More Details ›
        </div>
      </div>
    </div>
    `;
  }
  return desktopHTML;
}

function productComboKit(response) {
    const productData = response.product_Ids;
    const priceCart = response.cart_price
    
    let proDetEle = document.querySelector('.product-combo-details');
    proDetEle.innerHTML = '';
    const containerDiv = document.createElement('div');
    containerDiv.classList.add('kit-container', 'container');
    const valiedChatCase = caseId && /^[0-7]/.test(caseId);
    // if(!valiedChatCase){
       document.body.classList.add('control-user')
    // }
    const header = document.createElement('h2');
    header.classList.add('kit-header', 'section-heading-font');
    header.innerText = 'Month 1 Doctor-Prescribed Kit';
    containerDiv.appendChild(header);
  
    if(window.innerWidth <= 767){
      containerDiv.classList.remove('container');
    }

    const matchingExtraData = response.extraDataForProducts.find((extra) => {
      return extra.productId === response.product_Ids[index].product_id;
    });
    
    let dosageTag = '';
    let usageOneLiner = '';
    dosageTag = matchingExtraData?.howToUseData?.dosage_tag;
    usageOneLiner = matchingExtraData?.howToUseData?.usage_one_liner;

    // ── OPTIMIZATION: use a DocumentFragment so all cards are inserted in 1 reflow ──
    const fragment = document.createDocumentFragment();

    productData.forEach((each) => {
      const tagsArray = each.tag.tagKeyArray;
      let tagsHTML = '';
      if (tagsArray.length > 1) {
        tagsHTML = tagsArray
          .map(tag => `<p class="tag-title">${tag}</p>`)
          .join('');
      } else {
        tagsHTML = `<p class="tag-title">${tagsArray[0]}</p>`;
      }
      const productDiv = document.createElement('div');
      productDiv.classList.add('kit-card-container');
      productDiv.dataset.productId = each.product_id;
      productDiv.dataset.productName = each.name;
      productDiv.innerHTML = renderProductCard(each, usageOneLiner);
      fragment.appendChild(productDiv);   // append to fragment, not live DOM
      if(getCookie("GuestForm_id")){
        variantsIDs.push({
          'id': each.product_id,
          'quantity': 1,
          properties: {
            '_result_id': id
          }
        });
      }else{
        variantsIDs.push({
          'id': each.product_id,
          'quantity': 1
        });
      }
    });

    proDetEle.appendChild(fragment);  // single DOM write = single reflow
    // ── END OPTIMIZATION ──
    const HAIR_COACH_IMG = '//traya.health/cdn/shop/files/Ishani.webp?v=1755771351&width=1500';
    const DIET_PLAN_IMG  = '//traya.health/cdn/shop/files/Frame_fd537927-e08a-4b43-b058-2b43db60ccd3.webp?v=1758090017&width=1500';
    const staticCards = [
      { id: 'hair-coach-support',   name: 'Hair Coach Support',    oneLiner: 'Hair Coach is there to support you in your journey.', image: HAIR_COACH_IMG },
      { id: 'customised-diet-plan', name: 'Customised Diet Plan',  oneLiner: 'Hair Coach is there to support you in your journey.', image: DIET_PLAN_IMG }
    ];

    staticCards.forEach(c => {
      const div = document.createElement('div');
      div.className = 'kit-card-container';
      div.dataset.productId = c.id;
      div.dataset.productName = c.name;
      div.dataset.ccStatic = 'true';
      div.innerHTML = `
        <div class="kit-card--wrapper">
          <div class="cc-card cc-card--no-arrow">
            <div class="cc-card__image">
              <img src="${c.image}" alt="${c.name}" width="72" height="72" loading="lazy"/>
            </div>
            <div class="cc-card__content">
              <h3 class="cc-card__title">${c.name}</h3>
              <p class="cc-card__oneliner">${c.oneLiner}</p>
            </div>
            <div class="arrow-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
                <path d="M6.5306 7.03062L1.5306 12.0306C1.3897 12.1715 1.19861 12.2507 0.999348 12.2507C0.80009 12.2507 0.608994 12.1715 0.468098 12.0306C0.327201 11.8897 0.248047 11.6986 0.248047 11.4994C0.248047 11.3001 0.327201 11.109 0.468098 10.9681L4.93747 6.5L0.469348 2.03062C0.399583 1.96086 0.344243 1.87804 0.306486 1.78689C0.26873 1.69573 0.249297 1.59804 0.249297 1.49937C0.249297 1.40071 0.26873 1.30302 0.306486 1.21186C0.344243 1.12071 0.399583 1.03789 0.469348 0.968125C0.539113 0.89836 0.621936 0.843019 0.713088 0.805263C0.80424 0.767507 0.901936 0.748074 1.0006 0.748074C1.09926 0.748074 1.19696 0.767507 1.28811 0.805263C1.37926 0.843019 1.46208 0.89836 1.53185 0.968125L6.53185 5.96812C6.60169 6.03788 6.65707 6.12074 6.69481 6.21195C6.73256 6.30316 6.75193 6.40092 6.75181 6.49963C6.7517 6.59834 6.7321 6.69606 6.69414 6.78718C6.65617 6.8783 6.6006 6.96103 6.5306 7.03062Z" fill="black"/>
              </svg>
            </div>
          </div>
        </div>
      `;
      div.addEventListener('click', e => e.stopPropagation(), true);
      fragment.appendChild(div);   // ← changed from container to fragment
    });

    // ---- single flush ----
    proDetEle.appendChild(fragment);

    const removedProducts = [];
    let selectedVariantId = null;
    let selectedProductElement = null;
    
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.product-remove-btn');
      if (!btn) return;
    
      const productName = btn.getAttribute('data-product-name');
      const productImage = btn.getAttribute('data-product-image');
      selectedVariantId = btn.getAttribute('data-variant-id');

      updateRemovePopupContentByProduct(productName, productImage, selectedVariantId);
      selectedProductElement = document.querySelector(`.kit-card-container[data-product-id="${selectedVariantId}"]`);
       
      fireEvent("delete_product_clicked", caseId, selectedVariantId, productName);
    
      const removePopup = document.getElementById('remove-confirmation-popup');
      removePopup.classList.add('popup-visible');
    });

    document.querySelector('.remove-popup-remove-btn').addEventListener('click', async function () {
      if (!selectedVariantId) return;
      const removeBtn = this;
      removeBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_3.svg?v=1741241123"
             class="loader-icon" alt="Loading..." style="width: 20px; height: 20px;" />`;

      try {
        const cart = await fetch('/cart.js').then(res => res.json());
        const lineItem = cart.items.find(item => item.variant_id == selectedVariantId);
        if (!lineItem) return;
    
        await removeCartItemByKey(lineItem.key);

        selectedProductElement.classList.add('fade-out');
        setTimeout(() => {
          selectedProductElement.remove();
          const removedFromKit = bundleMap.bundle1.find(p => p.variantId === selectedVariantId);
          if (removedFromKit) {
            restoreProductToOptionalList(removedFromKit, response);
            removeBtn.innerHTML = `Remove`;
          }
        }, 300);

        if (!removedProducts.includes(selectedVariantId)) {
          removedProducts.push(selectedVariantId);
          const removedProduct = productData.find(p => p.product_id === selectedVariantId);
          if (removedProduct) {
            renderRemovedProductCard(removedProduct);
            removeBtn.innerHTML = `Remove`;
          }
        }
    
        document.getElementById('remove-confirmation-popup').classList.remove('popup-visible');
    
        const updatedCart = await fetch('/cart.js').then(res => res.json());
        if (updatedCart.items.length === 1) {
          showCartAlmostEmptyPopup();
          const productListWrapper = document.querySelector('.product-combo-details');
          if (productListWrapper) {
            const allProductCards = productListWrapper.querySelectorAll('.kit-card-container');
            allProductCards.forEach(card => card.remove());
          }
        }
    
        const newTotal = updatedCart.items.reduce((sum, item) => sum + item.final_line_price, 0);
        const formattedTotal = `₹${Math.round(newTotal / 100).toLocaleString('en-IN')}`;
        updateStrikePriceAfterRemoval(response, selectedVariantId); 
      } catch (err) {
        console.error('Error during removal:', err);
      }
    });

    function updateCartTotalPrice() {
      fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartTotal = cart.total_price / 100;
        document.querySelectorAll('.total-price').forEach(el => {
          el.textContent = `₹${cartTotal}`;
        });
      });
    }

    function showCartAlmostEmptyPopup() {
      // Fetch cart state first to avoid calling clear.js on an already-empty cart.
      // Excessive clear.js calls on empty carts trigger Cloudflare bot detection on Shopify's CDN.
      fetch('/cart.js').then(r => r.json()).then(cartState => {
        if ((cartState.item_count || 0) > 0) fetch('/cart/clear.js');
      });

      const popup = document.getElementById('remove-confirmation-popup');
      const popupBox = popup.querySelector('.remove-popup-box');
    
      if (popup && popupBox) {
        popupBox.innerHTML = `
          <div class="remove-popup-flex">
            <h2 class="empty-cart-title">Your Cart is Empty</h2>
            <p class="empty-cart-msg">You have removed all products in your kit!</p>
          </div>
          <button class="go-back-btn" style="margin-top: 20px;" onclick="window.location.href = window.location.href;">Go Back To Original Cart</button>
        `;
        popup.style.display = 'flex';
        popup.classList.add('popup-visible');
        document.body.style.overflow = 'hidden';
      }
    }
    // add product back to cart
     document.addEventListener('click', async function (e) {
      if (e.target.classList.contains('add-removed-to-cart-btn')) {
        const variantId = e.target.getAttribute('data-variant-id');
      
        e.target.disabled = true;
        e.target.classList.add('disabled');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
          }),
        })
          .then((response) => {
            localStorage.setItem('User_location', "cart");
            return response.json();
          })
          .then((result) => {
            updateCartDrawer();
            const index = removedProducts.indexOf(variantId);
            if (index > -1) {
              removedProducts.splice(index, 1);
              console.log('Removed product restored:', variantId);
            }
            const restoredProduct = productData.find(p => p.product_id === variantId);
            if (!restoredProduct) return;
            
            fireEvent("add_back", caseId, restoredProduct.product_id, restoredProduct.name);
    
            const tagsArray = restoredProduct.tag.tagKeyArray;
            const tagsHTML = tagsArray.map(tag => `<p class="tag-title">${tag}</p>`).join('');
            const dosageTag = restoredProduct.dosageTag;
            const usageOneLiner = restoredProduct.usageOneLiner;
    
            const productDiv = document.createElement('div');
            productDiv.classList.add('kit-card-container', 'fade-in');
            productDiv.dataset.productId = restoredProduct.product_id;
            productDiv.dataset.productName = restoredProduct.name;
    
            productDiv.innerHTML = renderProductCard(restoredProduct, usageOneLiner);
    
            const proDetEle = document.querySelector('.product-combo-details'); 
            if (proDetEle) {
              setTimeout(() => {
                proDetEle.appendChild(productDiv);
              }, 50);
            }
    
            e.target.closest('.removed-product')?.remove();
    
            const removedList = document.querySelectorAll('.removed-product');
            if (removedList.length === 0) {
              document.querySelector('.removed-products-flex').classList.add('d-none');
            }
            updateStrikePriceAfterAddition(response, variantId);
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }
    });
    document.querySelector('.remove-popup-keep-btn').addEventListener('click', function () {
      selectedProductElement = null;
      selectedVariantId = null;
      document.getElementById('remove-confirmation-popup').classList.remove('popup-visible');
    });
    // CLOSE POPUP ON OVERLAY CLICK
    const popupOverlay = document.getElementById("remove-confirmation-popup");

    if (popupOverlay) {
      popupOverlay.addEventListener("click", function (e) {
        const popupBox = document.querySelector(".remove-popup-box");
        if (!popupBox.contains(e.target)) {
          document.querySelector(".remove-popup-keep-btn")?.click();
        }
      });
    }
}

const bundleMap = {
  bundle1: [
    {
      "variantId": "47301151064242",
      "name": "Defence Shampoo",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Product_1_86e4caf1-109f-4f35-a88c-3bc4b35e869c.webp?v=1763373344",
      "one_liner": "Hydrates Deeply and Reduces Dryness",
      "tag": "Cleans scalp",
      "price": "267.00",
      "originalPrice": "300"
    },
    {
      "variantId": "44650256728242",
      "name": "Defence conditioner",
      "image_url": "https://dvv8w2q8s3qot.cloudfront.net/products/product_single_images/defenceConditioner50mg1.png",
      "one_liner": "Conditions and Smoothens Hair Texture",
      "tag": "Softens Hair",
      "price": "320.00"
    },
    {
      "variantId": "46528923304114",
      "name": "Anti Dandruff Lotion",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Anti_Dandruff_Solution.webp?v=1765353677",
      "one_liner": "Night Lotion fights dandruff to help reduce hair fall.",
      "tag": "Clears Dandruff",
      "price": "355.00",
      "originalPrice": "399"
    },
    {
      "variantId": "47303097352370",
      "name": "Hair vitamin for her",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property.webp?v=1766144058",
      "one_liner": "Supplements to meet Hair's Nutrition needs.",
      "tag": "Nourishes Hair",
      "price": "463.00",
      "originalPrice": "520"
    },
    {
      "variantId": "47301148803250",
      "name": "Shine serum",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/shine_leave_in_serum.webp?v=1771394293",
      "one_liner": "Shine Serum enhances hair texture for a vibrant, healthy look.",
      "tag": "Adds Shine",
      "price": "599.00"
    },
    {
      "variantId": "47329496826034",
      "name": "Anti-Dandruff Shampoo",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Anti_Dandruff_Shampoo2.webp?v=1765353725",
      "one_liner": "Anti-Dandruff Shampoo fights dandruff to help reduce hair fall.",
      "tag": "Clears dandruff",
      "price": "281.00",
      "originalPrice": "300"
    }
  ]
};

function optionalAddOnProducts(response) {
  const productCardContainers = document.querySelector(".optional-add-ons-wrapper");
  const optionalProductBundle = bundleMap['bundle1'];
  const responseProductData = response.product_Ids;
  const excludedIds = new Set(["44650256728242"]);
  const variationProductsCaseId =  caseId && /^[0-7]/.test(caseId);
  const existingVariantIds = new Set(
    responseProductData
      .map(p => String(p.product_id))
      .filter(id => !excludedIds.has(id))
  );
  if (!optionalProductBundle) return;
  document.querySelector('.optional-add-ons-section').classList.remove('d-none');

  // ── OPTIMIZATION: batch optional add-on cards into a DocumentFragment (1 reflow) ──
  const fragment = document.createDocumentFragment();
  optionalProductBundle.forEach((optionalProduct) => {
    if (existingVariantIds.has(optionalProduct.variantId)) {
      return;
    }
    const productDiv = document.createElement('div');
    productDiv.classList.add('optional-add-ons-list');
    productDiv.dataset.productId = optionalProduct.variantId;
    productDiv.dataset.productName = optionalProduct.name;
    productDiv.innerHTML = `
        <div class="optional-add-ons-card">
            <img src="${optionalProduct.image_url}" alt="${optionalProduct.name}"  width="100px" height="100px" loading="lazy" class="optional-addon-image p-image"/>
            <div class="optional-add-ons-info">
              <h2 class=optional-addon-title p-title">${optionalProduct.name}</h2>
              <p class="optional-addon-oneliner liner-text d-none">${optionalProduct.one_liner}</p>
              <div class="optional-addon-price-button-flex">
                <p class="optional-addon-price p-price d-none">
                    ${optionalProduct.price ? `₹${Math.floor(optionalProduct.price)}`: `₹${Math.floor(optionalProduct.price)}`}
                </p>
                <p class="optionalProduct-tag">${optionalProduct.tag}</p>
                <button class="optional-add-btn" data-variant-id="${optionalProduct.variantId}" data-product-name="${optionalProduct.name}" data-product-image="${optionalProduct.image_url}">Add</button>
                </div>
          </div>
        </div>
    `;
    fragment.appendChild(productDiv);
  });
  productCardContainers.appendChild(fragment);  // single DOM write
  // ── END OPTIMIZATION ──

document.addEventListener('click', async function (e) {
    const addBtn = e.target.closest('.optional-add-btn');
    if (!addBtn) return;
    const variantId = addBtn.getAttribute('data-variant-id');
    const productName = addBtn.getAttribute('data-product-name');
    const productImage = addBtn.getAttribute('data-product-image');
    fireEvent("addon_add_to_cart_click", caseId, variantId, productName);
    addBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_3.svg?v=1741241123"
        class="loader-icon" alt="Loading..." style="width: 22px; height: 20px;" />`;
    addBtn.disabled = true;
    addBtn.classList.add('disabled');
    try {
        const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: variantId,
                quantity: 1,
                properties: {}
            })
        });
        updateCartDrawer();
        insertAddOnProductIntoKit(optionalProductBundle, variantId, existingVariantIds);
        updateStrikePriceAfterAddition(response, variantId, 'optional');
        e.target.closest('.optional-add-ons-list').remove();
        addBtn.innerHTML = `Add`;
        addBtn.disabled = false;
        addBtn.classList.remove('disabled');
        if(document.querySelectorAll('.optional-add-ons-list').length == 0){
          document.querySelector('.optional-add-ons-section').classList.add('d-none');
        }
    } catch (err) {
        console.error('Error adding to cart:', err);
    }
  });
}

function insertAddOnProductIntoKit(optionalProducts, variantId, existingVariantIds) {

  if (existingVariantIds.has(String(variantId))) {
    return;
  }

  const product = optionalProducts.find(p => p.variantId === variantId);
  if (!product) return;

  const container = document.querySelector('.product-combo-details');
  if (!container) return;

  const insertProductDetails = document.createElement('div');
  insertProductDetails.classList.add('kit-card-container', 'fade-in');

  insertProductDetails.dataset.productId = product.variantId;
  insertProductDetails.dataset.productName = product.name;
  const normalizedProduct = {
    ...product,
    product_id: product.variantId,
    oneLiner: product.one_liner || product.oneliner,
    image_url: {
      singleImage: product.image_url || product.productImage || product.image
    },
    price: product.price,
    originalPrice: product.originalPrice
  };

  insertProductDetails.innerHTML = renderProductCard(
    normalizedProduct,
    product.one_liner
  );

  container.appendChild(insertProductDetails);
}

function restoreProductToOptionalList(product, response) {
    const responseProductData = response.product_Ids;
    const existingVariantIds = new Set(
      responseProductData.map(p => String(p.product_id))
    );
    const container = document.querySelector('.optional-add-ons-wrapper');
    if (!container) return;
    const restoreOptionalProduct = document.createElement('div');
    if (existingVariantIds.has(String(product.variantId))) {
      return;
    }
    restoreOptionalProduct.classList.add('optional-add-ons-list');
    restoreOptionalProduct.dataset.productId = product.variantId;

    restoreOptionalProduct.innerHTML = `
        <div class="optional-add-ons-card">
            <img src="${product.image_url}" alt="${product.name}"  width="100px" height="100px" loading="lazy" class="optional-addon-image p-image"/>
            <div class="optional-add-ons-info">
              <h2 class=optional-addon-title p-title">${product.name}</h2>
              <p class="optional-addon-oneliner liner-text d-none">${product.one_liner}</p>
              <div class="optional-addon-price-button-flex">
                <p class="optional-addon-price p-price">
                    ${product.price ? ` ₹${Math.floor(product.price)}`: `₹${Math.floor(product.price)}`}
                </p>
                <p class="optionalProduct-tag">${product.tag}</p>
                <button class="optional-add-btn" data-variant-id="${product.variantId}" data-product-name="${product.name}" data-product-image="${product.image_url}">Add</button>
                </div>
          </div>
        </div>
    `;

    container.appendChild(restoreOptionalProduct);

    if(document.querySelectorAll('.optional-add-ons-list').length > 0){
      document.querySelector('.optional-add-ons-section').classList.remove('d-none');
    }
}

function fireEvent(eventName, caseID, productId, productName) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "productId": productId,
          "productName": productName,
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}
function productFireEvent(eventName, caseID, productName) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "productName": productName,
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}
function fireVideoEvent(eventName, caseID, videoURL, videoTitle) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "videoURL": videoURL,
          "videoTitle": videoTitle,
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}

function fireClinicEvent(eventName, caseID) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}
// WhatsApp Tooltip Animation Function
function initWhatsAppTooltipAnimation() {
  const tooltip = document.querySelector('.whats-app-tooltip');
  if (!tooltip) return;
  function showAndHideTooltip() {
    setTimeout(() => {
      tooltip.classList.add('show');
      tooltip.classList.remove('fade-out');
      setTimeout(() => {
        tooltip.classList.add('fade-out');
        tooltip.classList.remove('show');
      }, 5000);

    }, 10000);
  }
  showAndHideTooltip();
  setInterval(showAndHideTooltip, 15000);
}

function updateStrikePriceAfterRemoval(response, removedVariantId) {
  const strikeEls = document.querySelectorAll('.strike-cart-total-price');
  const totalEls = document.querySelectorAll('.total-price');

  let currentStrikePrice = parseInt(
    strikeEls[0]?.textContent.replace(/[^\d]/g, '')
  ) || 0;

  let currentTotalPrice = parseInt(
    totalEls[0]?.textContent.replace(/[^\d]/g, '')
  ) || 0;

  let removedProduct =
    response.product_Ids.find(p => String(p.product_id) === String(removedVariantId)) ||
    bundleMap?.bundle1?.find(p => String(p.variantId) === String(removedVariantId));

  if (!removedProduct) return;

  const removedOriginalPrice = Number(
    removedProduct.originalPrice || removedProduct.price || 0
  );

  const removedSellingPrice = Number(
    removedProduct.price || 0
  );

  let rawStrikePrice = currentStrikePrice - removedOriginalPrice;
  let rawTotalPrice = currentTotalPrice - removedSellingPrice;

  let discountAmount = 0;
  if (
    window.appliedDiscountMeta &&
    rawTotalPrice >= window.appliedDiscountMeta.minCart
  ) {
    if (window.appliedDiscountMeta.type === 'percentage') {
      discountAmount = Math.round(
        (rawTotalPrice * window.appliedDiscountMeta.value) / 100
      );
    } else {
      discountAmount = window.appliedDiscountMeta.value;
    }
  }

  const updatedTotalPrice = Math.max(rawTotalPrice - discountAmount, 0);

  strikeEls.forEach(el => {
    el.textContent = `₹${Math.round(rawStrikePrice).toLocaleString('en-IN')}`;
  });

  totalEls.forEach(el => {
    el.textContent = `₹${Math.round(updatedTotalPrice).toLocaleString('en-IN')}`;
  });
}

function updateStrikePriceAfterAddition(response, variantId, type) {
  const strikeEls = document.querySelectorAll('.strike-cart-total-price');
  const totalEls = document.querySelectorAll('.total-price');

  let currentStrikePrice = parseInt(
    strikeEls[0]?.textContent.replace(/[^\d]/g, '')
  ) || 0;

  let currentTotalPrice = parseInt(
    totalEls[0]?.textContent.replace(/[^\d]/g, '')
  ) || 0;

  let addedProduct = null;

  if (type === "kit") {
    addedProduct = response.product_Ids.find(
      p => String(p.product_id) === String(variantId)
    );
  }

  if (type === "optional") {
    addedProduct = bundleMap?.bundle1?.find(
      p => String(p.variantId) === String(variantId)
    );
  }

  if (!addedProduct) return;

  const addedOriginalPrice = Number(
    addedProduct.price || addedProduct.price || 0
  );

  const addedSellingPrice = Number(
    addedProduct.price || 0
  );

  let rawStrikePrice = currentStrikePrice + addedOriginalPrice;
  let rawTotalPrice = currentTotalPrice + addedSellingPrice;

  let discountAmount = 0;
  if (
    window.appliedDiscountMeta &&
    rawTotalPrice >= window.appliedDiscountMeta.minCart
  ) {
    if (window.appliedDiscountMeta.type === 'percentage') {
      discountAmount = Math.round(
        (rawTotalPrice * window.appliedDiscountMeta.value) / 100
      );
    } else {
      discountAmount = window.appliedDiscountMeta.value;
    }
  }

  const updatedTotalPrice = Math.max(rawTotalPrice - discountAmount, 0);

  strikeEls.forEach(el => {
    el.textContent = `₹${Math.round(rawStrikePrice).toLocaleString('en-IN')}`;
  });

  totalEls.forEach(el => {
    el.textContent = `₹${Math.round(updatedTotalPrice).toLocaleString('en-IN')}`;
  });
}
function removeCartItemByKey(lineItemKey) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineItemKey, quantity: 0 })
  })
  .then(res => res.json())
  .then(cart => {
    updateCartDrawer();    
  })
  .catch(err => console.error('Error removing item:', err));
}
function bindCartDrawerEvents() {
  const closeBtn = document.querySelector('.drawer__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      document.querySelector('cart-drawer.drawer')?.classList.remove('active');
      document.querySelector('.cart-drawer__overlay')?.classList.remove('active');
    });
  }
}

function updateCartDrawer() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const updates = {};

      cart.items.forEach(item => {
        if (item.quantity === 2) {
          updates[item.key] = 1; 
        }
      });
      if (Object.keys(updates).length > 0) {
        const body = {
          updates: updates
        };

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        })
        .then(res => res.json())
        .then(() => {
          refreshCartUI();
        })
        .catch(err => console.error('Error updating quantities:', err));
      } else {
        refreshCartUI();
      }
    });
}

function refreshCartUI() {
  fetch('/?sections=cart-icon-bubble')
    .then(res => res.json())
    .then(data => {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble && data['cart-icon-bubble']) {
        cartIconBubble.innerHTML = data['cart-icon-bubble'];
      }
    });

  fetch('/?sections=cart-drawer')
    .then(res => res.json())
    .then(data => {
      const cartDrawerHTML = data['cart-drawer'];
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawerHTML) {
        cartDrawer.outerHTML = cartDrawerHTML;
        setTimeout(() => {
          bindCartDrawerEvents?.();
        }, 50);
        document.querySelectorAll('.cart-drawer .cart-item cart-remove-button, .cart-drawer quantity-input.quantity').forEach(el => {
          el.style.display = 'none';
        });
      }
    })
    .catch(err => console.error('Error updating cart drawer:', err));
    let drawerTotalPrice = document.querySelectorAll('.totals__subtotal-value .drawer-strike-cart-total-price');
    setTimeout(() => {
      if (drawerTotalPrice.length !== 0) {
        drawerTotalPrice.forEach((price) => {
          price.innerHTML = `₹ ${strikeFinalCartPrice}`;
        });
      }
    },1000 );
}

bindCartDrawerEvents();

function renderRemovedProductCard(product) {
  document.querySelector('.removed-products-flex').classList.remove('d-none')
  const container = document.getElementById('removed-products-container');
  const productCard = document.createElement('div');
  productCard.className = 'removed-product';
  const price = product.product_id === "45277154377906" ? `₹0` : `₹${Math.round(product.price)}`;

  fireEvent("delete_product", caseId, product.product_id, product.name);
  productCard.innerHTML = `
    <div  class="removed-products-wrapper">
      <div class="removed-product-image">
        <img src="${product.image_url.singleImage}" width="60" height="60" alt="${product.name}">
      </div>
      <div>
        <div class="removed-products-title">${product.name}</div>
        <div class="removed-products-price">${price}</div>
      </div>
      <button class="add-removed-to-cart-btn" data-variant-id="${product.product_id}">Add to Cart</button>
    </div>
  `;

  container.appendChild(productCard);
}

const popOneLinerData = [
  {
    product: "Her Santulan",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/her_santulan_1f4b7e30-172b-4a88-8e98-a700d47fd4eb.webp?v=1773122932",
    productVariantId: "46466095906994",
    oneliner: "Her Santulan supports daily wellness to maintain healthy hair.",
    ingredientName: "Shatavari | Brahmi",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Shatavari.webp?v=1770375027 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Brahmi.webp?v=1770375027",
    ingredientContent: "Shatavari helps balance internal heat and hormones, which in turn helps promote healthy hair. | Calms scalp stress response, supporting healthier follicle activity and reduced hair fall.",
  },
  {
    product: "Mom Santulan for Postpartum hair",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/mom_santulan_3c406b34-dfbe-4ecc-a615-e2e2ec9f32fc.webp?v=1773122932",
    productVariantId: "46466402779314",
    oneliner: "Mom Santulan helps reduce post-partum hair fall.",
    ingredientName: "Vidarikand | Lodhra",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Vidarikand.webp?v=1770375187 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Lodhra.webp?v=1770375186",
    ingredientContent: "Nourishes hair roots by supporting hormonal balance and tissue strength. | Helps balance scalp oiliness and supports a healthier follicle environment.",
  },
  {
    product: "Iron Santulan",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/iron_santulan_7813afaa-5414-4107-9b80-a1be43b00b63.webp?v=1773122932",
    productVariantId: "46465792704690",
    oneliner: "Iron Santulan helps reduce hair fall caused by anemia.",
    ingredientName: "Navayasa Loh | Pippali",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Navayasa.webp?v=1770375340 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Pippali.png?v=1770375365",
    ingredientContent: "Helps correct iron-related deficiencies that contribute to excessive hair fall. | Improves metabolism and circulation, helping nutrients reach hair follicles efficiently.",
  },
  {
    product: "Thyro Santulan",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/thyro_santulan_03953df7-f945-40c0-896b-edf7521ba888.webp?v=1773122932",
    productVariantId: "46466225438898",
    oneliner: "Thyro Santulan helps reduce hair fall caused by thyroid issues.",
    ingredientName: "Chandraprabha Vati | Triphala",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Chandraprabhavati.png?v=1770375642 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Triphala.png?v=1758868752",
    ingredientContent: "Supports hormonal balance and metabolic health, helping reduce internally triggered hair fall. | Supports detox and nutrient absorption for healthier hair growth",
  },
  {
    product: "Gut Shuddhi",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/gutt_shuddhi_81469b73-b40c-4d07-b98e-9fc5f364c177.webp?v=1773122932",
    productVariantId: "46528902496434",
    oneliner: "Gut Shuddhi supports digestion to help reduce hair fall.",
    ingredientName: "Amla | Sunth",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Sunth.webp?v=1770375802",
    ingredientContent: "Rich in antioxidants, strengthens hair roots and supports hair growth. | Enhances blood flow and nutrient delivery to support healthy hair growth.",
  },
  {
    product: "Digest boost for Improved Digestive Ability",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/digest_boost_7ac2e221-36b5-4c74-9c62-9220d8d707b7.webp?v=1773122932",
    productVariantId: "46528963936434",
    oneliner: "Digest Boost supports digestion to help reduce hair fall.",
    ingredientName: "Variyali | Ganthoda",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Variyali.webp?v=1770376077 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/ganthoda.webp?v=1770376091",
    ingredientContent: "Improves digestion and reduces internal heat, supporting healthier hair growth from within. | Boosts circulation and digestion, supporting nourishment to hair follicles.",
  },
  {
    product: "Health Tatva",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/health_tatva_8fbfa017-240b-476b-9941-082f4f69156c.webp?v=1773122932",
    productVariantId: "46528920289458",
    oneliner: "Health Tatva helps in boosting metabolism.",
    ingredientName: "Sunth | Pippali",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Sunth.webp?v=1770375802 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Pippali.png?v=1770375365",
    ingredientContent: "Improves blood circulation and digestion, helping nutrients reach hair follicles effectively. | Improves metabolism and circulation, helping nutrients reach hair follicles efficiently.",
  },
  {
    product: "Hair Vitamin for her",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/hair_vitamin_her.webp?v=1773122933",
    productVariantId: "47303097352370",
    oneliner: "Hair Vitamin addresses nutritional deficiency to reduce hair fall.",
    ingredientName: "Biotin | Amino Acids",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Amino_Acids.webp?v=1770376900",
    ingredientContent: "Supports keratin production, helping strengthen hair and reduce breakage. | Build keratin structure, improving hair strength, thickness, and resistance to breakage.",
  },
  {
    product: "Hair Vitamin",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/hair_vitamin_4b815fc7-1797-4776-aee7-08d81b7910fa.webp?v=1773122933",
    productVariantId: "47303072710834",
    oneliner: "Hair Vitamin addresses nutritional deficiency to reduce hair fall.",
    ingredientName: "Biotin | Pumpkin Seed Extract",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Pumpkin_Seed_Extract.png?v=1758868752",
    ingredientContent: "Supports keratin production, helping strengthen hair and reduce breakage. | Helps block DHT activity, supporting reduced hair thinning.",
  },
  {
    product: "Calm Ras",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/calm_ras_b430a71f-5841-475c-b4fa-7e8008b124cd.webp?v=1773122932",
    productVariantId: "46465726513330",
    oneliner: "Calm Ras helps to reduce hair fall caused by stress.",
    ingredientName: "Ashwagandha | Brahmi",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Ashwagandha.webp?v=1770377173 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Brahmi.webp?v=1770375027",
    ingredientContent: "Ashwagandha helps reduce stress and encourages blood circulation in the scalp, thereby encouraging hair growth. | Prolongs hair growth phase and strengthens roots, supporting thicker and healthier hair regrowth.",
  },
  {
    product: "Nasal Ghrit",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/ghrit.webp?v=1773122932",
    productVariantId: "46466175008946",
    oneliner: "Nasal Ghrit promotes better sleep to help reduce hair fall.",
    ingredientName: "Cow Ghee | Shatavari",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Cow_Ghee_1.png?v=1758868752 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Shatavari.webp?v=1770375027",
    ingredientContent: "Deeply moisturizes scalp and supports repair of dry, brittle hair shafts. | Supports hormonal balance and nourishment of hair follicles in women.",
  },
  {
    product: "Hair Ras",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/hair_ras_e242cfaf-dd81-44a7-ba77-21f4004a73b6.webp?v=1773122932",
    productVariantId: "46528906821810",
    oneliner: "Hair Ras provides essential nourishment for stronger, healthier hair.",
    ingredientName: "Ashwagandha | Bringhraj",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Ashwagandha.webp?v=1770377173 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj.webp?v=1770379802",
    ingredientContent: "Ashwagandha helps reduce stress and encourages blood circulation in the scalp, thereby encouraging hair growth. | Reduces stress hormones and improves scalp nourishment, helping control stress-related hair fall.",
  },
  {
    product: "Anti-Dandruff Shampoo",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/anti_dandruff_shampoo_e51702d8-80e1-4ffb-b331-88c837162493.webp?v=1773122932",
    productVariantId: "47329496826034",
    oneliner: "Anti-Dandruff Shampoo fights dandruff to help reduce hair fall.",
    ingredientName: "Ketocanozole 2% | AleoVera",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Anti-dandruff_keto.webp?v=1770380073 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/aloe_vera.webp?v=1770296912",
    ingredientContent: "Reduces dandruff-causing fungus and scalp inflammation linked to hair loss. | Helps reduce scalp dryness and flaking that can weaken hair roots.",
  },
  {
    product: "Recap Serum",
    productImage : "",
    productVariantId: "41645770309810",
    oneliner: "Recap Serum supports hair regrowth for fuller, healthier hair.",
    ingredientName: "",
    ingredientImage: "",
    ingredientContent: "",
  },
  {
    product: "Ketoconazole 2% night lotion",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/anti_dandruff_night_lotion.webp?v=1773122932",
    productVariantId: "46528923304114",
    oneliner: "Night Lotion fights dandruff to help reduce hair fall.",
    ingredientName: "Ketocanozole 2% | AleoVera",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Anti-dandruff_keto.webp?v=1770380073 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/aloe_vera.webp?v=1770296912",
    ingredientContent: "Reduces dandruff-causing fungus and scalp inflammation linked to hair loss. | Soothes irritated scalp and supports moisture balance for healthier hair growth.",
  },
  {
    product: "Scalp Oil 100ml with Dandruff Oil Shot",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/scalp_oil_100ml_dandruff_oil_shot_75ba5254-6e4d-4ab4-9b9d-813b82200be1.webp?v=1773122932",
    productVariantId: "46530320040114",
    oneliner: "Scalp Oil nurtures scalp health to support stronger hair.",
    ingredientName: "Camphor | Castor oil",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Camphor.webp?v=1770380600 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/CastorOil.webp?v=1770297142",
    ingredientContent: "Improves scalp circulation and helps relieve itchiness linked to hair fall. | Nourishes scalp and supports thicker-looking hair by strengthening strands.",
  },
  {
    product: "Scalp Oil 100ml with Scalp Health Oil Shot",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/scalp_oil_50ml_scalp_shot.webp?v=1773122932",
    productVariantId: "46531529638066",
    oneliner: "Scalp Oil nurtures scalp health to support stronger hair.",
    ingredientName: "Bergamot | ORPL",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bergamot.webp?v=1770380916 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/ORPL.webp?v=1770380916",
    ingredientContent: "Helps balance oily scalp and supports a healthier scalp environment. | Helps improve hair fibre strength and reduces breakage from daily stress.",
  },
  {
    product: "Scalp Oil 100ml with Calm Oil Shot",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/scalp_oil_100ml_calm_oil_shot_222213c0-d57b-403f-9472-29fc8caa5408.webp?v=1773122932",
    productVariantId: "46530283012274",
    oneliner: "Scalp Oil nurtures scalp health to support stronger hair.",
    ingredientName: "Coconut Oil | Amla",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property_13.webp?v=1770381512 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815",
    ingredientContent: "Penetrates hair shaft to reduce protein loss and strengthen strands. | Rich in antioxidants, strengthens hair roots and supports hair density.",
  },
  {
    product: "Scalp Oil 100ml with Growth Oil Shot",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/scalp_oil_100ml_growth_shot.webp?v=1773122932",
    productVariantId: "46530384527538",
    oneliner: "Scalp Oil nurtures scalp health to support stronger hair.",
    ingredientName: "Camphor | Wheat Germ",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Camphor.webp?v=1770380600 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property_14.webp?v=1770381631",
    ingredientContent: "Improves scalp circulation and helps relieve itchiness linked to hair fall. | Rich in vitamin E, supports scalp nourishment and hair strength.",
  },
  {
    product: "Nourish hair oil",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/nourish_hair_oil_314b3a0e-62e9-439b-896d-e97653385eb0.webp?v=1773122933",
    productVariantId: "47302951403698",
    oneliner: "Nourish Oil deeply nourishes hair for strength and shine.",
    ingredientName: "Argan Oil | Rosemary Extract",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/ArganOil.webp?v=1770297123 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Rosemary_Oil.png?v=1758868752",
    ingredientContent: "Rich in fatty acids, improves hair elasticity and reduces breakage. | Improves scalp circulation and supports thicker hair growth.",
  },
  {
    product: "Her Nourish",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/her_nourish.webp?v=1773129965",
    productVariantId: "47302857621682",
    oneliner: "Protects hair from harmonal hair fall",
    ingredientName: "Deodar | Latakranj",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Deodar.webp?v=1770616150 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Latakranj.webp?v=1770616191",
    ingredientContent: "Helps reduce scalp inflammation and microbial buildup that can weaken hair roots. | Traditionally used to support hair pigmentation and reduce premature greying.",
  },
  {
    product: "Shine Leave in Serum",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/shine_serum_7a3e136e-3b42-4c9b-87c7-dfc7d17aaac4.webp?v=1773122932",
    productVariantId: "47301148803250",
    oneliner: "Shine Serum enhances hair texture for a vibrant, healthy look.",
    ingredientName: "Dimethicone",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Dimethicone.webp?v=1770616417",
    ingredientContent: "Forms a protective layer to smooth hair and reduce friction-related breakage.",
  },
  {
    product: "Defence Shampoo 180ml",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/defence_shampoo_180ml_d8c40ac4-8f71-4272-9bae-ec8aca8d51c1.webp?v=1773122932",
    productVariantId: "47301151064242",
    oneliner: "Defence Shampoo ensures hair hygiene for a healthy scalp.",
    ingredientName: "Vitamin B3 | Biotin",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Vitamin_B3.webp?v=1770616654 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883",
    ingredientContent: "Improves scalp blood circulation, supporting healthier hair follicles. | Supports keratin production, helping improve hair strength and thickness.",
  },
  {
    product: "Defence Conditioner",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/defence_conditioner_a7689873-6f78-4fdf-8db9-751502e1ae80.webp?v=1773122932",
    productVariantId: "44650256728242",
    oneliner: "Defence conditioner improves hair quality by deeply moisturizing the hair strands",
    ingredientName: "Biotin | Hydrolysed Rice protein",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Hydrolysed_Rice_protein.webp?v=1770616808",
    ingredientContent: "Supports keratin production, helping strengthen hair and reduce breakage. | Strengthens hair strands, improves elasticity, and reduces breakage.",
  },
  {
    product: "Defence Conditioner 50g",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/defenceConditioner50mg1.webp?v=1743657581",
    productVariantId: "45277154377906",
    oneliner: "Defence conditioner improves hair quality by deeply moisturizing the hair strands",
    ingredientName: "Biotin | Hydrolysed Rice protein",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Hydrolysed_Rice_protein.webp?v=1770616808",
    ingredientContent: "Supports keratin production, helping strengthen hair and reduce breakage. | Strengthens hair strands, improves elasticity, and reduces breakage.",
  },
  {
    product: "Consti Clear for Improved Bowel Movement",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/consti_clear_6c553d57-1fe9-4eae-9afd-4613f4a28194.webp?v=1773122933",
    productVariantId: "46466005598386",
    oneliner: "Consti clear supports digestion to help reduce hair fall.",
    ingredientName: "",
    ingredientImage: "",
    ingredientContent: "",
  },
  {
    product: "Minoxidil 2%",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/minoxidil_2_cd28309f-2f80-465f-97d4-68f21c8eba54.webp?v=1773122932",
    productVariantId: "47329517568178",
    oneliner: "Minoxidil 2% promotes hair regrowth for thicker, fuller hair.",
    ingredientName: "Minoxidil 2% | Procapil 2%",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Minoxidil_2ing.webp?v=1770380305 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Procapil_2.webp?v=1770380316",
    ingredientContent: "Stimulates inactive follicles to support visible hair regrowth in early hair thinning. | Helps slow hair follicle ageing and supports reduced hair fall.",
  },
  {
    product: "Minoxidil 5%",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/minoxidil_5_39c0bb5f-6a2a-43c2-959e-c846a47b31a0.webp?v=1773122932",
    productVariantId: "47302891929778",
    oneliner: "Minoxidil 5% alcohol free promotes hair regrowth for thicker, fuller hair.",
    ingredientName: "Minoxidil 5% | Procapil 3%",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Minoxidil_2ing.webp?v=1770380305 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Procapil_2.webp?v=1770380316",
    ingredientContent: "Strongly activates follicles to promote denser, faster hair regrowth. | Helps slow hair follicle ageing and supports reduced hair fall.",
  },
  {
    product: "Minoxidil 5% alc free",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/minoxidil_finasteride_5__alcoholfree.webp?v=1773122932",
    productVariantId: "46465512898738",
    oneliner: "Minoxidil 5% alcohol free promotes hair regrowth for thicker, fuller hair.",
    ingredientName: "Minoxidil 5% | Procapil 3%",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Minoxidil_2ing.webp?v=1770380305 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Procapil_2.webp?v=1770380316",
    ingredientContent: "Strongly activates follicles to promote denser, faster hair regrowth. | Helps slow hair follicle ageing and supports reduced hair fall.",
  },
  {
    product: "Minoxidil 2% alc free",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/minoxidil_finasteride_2__alcoholfree.webp?v=1773122932",
    productVariantId: "46465596719282",
    oneliner: "Minoxidil 2% alcohol free promotes hair regrowth for thicker, fuller hair.",
    ingredientName: "Minoxidil 2% | Procapil 2%",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Minoxidil_2ing.webp?v=1770380305 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Procapil_2.webp?v=1770380316",
    ingredientContent: "Stimulates inactive follicles to support visible hair regrowth in early hair thinning. | Helps slow hair follicle ageing and supports reduced hair fall.",
  },
  {
    product: "Hair Santulan 01",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/her_santulan01.webp?v=1773122932",
    productVariantId: "47302996394162",
    oneliner: "Hair Santulan is customized to target internal root causes of your hair fall",
    ingredientName: "Bhringraj | Shatavari",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Shatavari.webp?v=1770375027",
    ingredientContent: "Bhringraj prevents hair thinning and keeps the scalp free of dandruff and excess grease. | Supports hormonal balance and follicle nourishment, helping reduce female-pattern hair thinning.",
  },
  {
    product: "Hair Santulan 02",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/her_santulan02.webp?v=1773122933",
    productVariantId: "47446793879730",
    oneliner: "Hair Santulan is customized to target internal root causes of your hair fall",
    ingredientName: "Amalki | Bhringraj",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930",
    ingredientContent: "supports collagen production and strengthens hair follicles at the root. | Nourishes hair roots and supports longer, stronger hair growth.",
  },
  {
    product: "Hair Santulan 03",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/her_santulan03.webp?v=1773122933",
    productVariantId: "47303079166130",
    oneliner: "Hair Santulan is customized to target internal root causes of your hair fall",
    ingredientName: "Amalki | Bhringraj",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930",
    ingredientContent: "supports collagen production and strengthens hair follicles at the root. | Nourishes hair roots and supports longer, stronger hair growth.",
  },
  {
    product: "Hair Active Serum",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Hair_Actives.webp?v=1773122932",
    productVariantId: "47300731568306",
    oneliner: "Hair Active Serum prevents hair thinning for fuller, healthier hair.",
    ingredientName: "3% Redensyl | 2% capixyl",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Redensyl.webp?v=1770627288 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Dimethicone.webp?v=1770616417",
    ingredientContent: "Activates hair follicles to support faster, denser hair regrowth. | Helps reduce hair fall and supports thicker, stronger hair regrowth.",
  },
  {
    product: "Hair Ras 01",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/hair_ras01.webp?v=1773122932",
    productVariantId: "47302757875890",
    oneliner: "Hair Ras is customized to target internal root causes of your hair fall.",
    ingredientName: "Amalki | Bhringraj",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930",
    ingredientContent: "Improves hair strength and supports natural hair growth. | Nourishes hair roots and supports longer, stronger hair growth.",
  },
  {
    product: "Hair Ras 02",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/hair_ras02.webp?v=1773122932",
    productVariantId: "47301161091250",
    oneliner: "Hair Ras is customized to target internal root causes of your hair fall.",
    ingredientName: "Bhringraj | Guduchi",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property_19.webp?v=1770627488",
    ingredientContent: "Nourishes the scalp and supports stronger, longer hair growth. | Reduces inflammation and supports scalp and hair follicle health.",
  },
  {
    product: "Hair Ras 05",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/hair_ras05.webp?v=1773122932",
    productVariantId: "46464896630962",
    oneliner: "Hair Ras is customized to target internal root causes of your hair fall.",
    ingredientName: "Amalki | Iron Bhasma",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Iron_Bhasma.webp?v=1770627628",
    ingredientContent: "supports collagen production and strengthens hair follicles at the root. | Helps correct iron deficiency, supporting healthy hair growth from within.",
  },
  {
    product: "Hair Ras 06",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/hair_ras06.webp?v=1773122932",
    productVariantId: "47301139169458",
    oneliner: "Hair Ras is customized to target internal root causes of your hair fall.",
    ingredientName: "Shatavari | Brahmi",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Shatavari.webp?v=1770375027 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Brahmi.webp?v=1770375027",
    ingredientContent: "Shatavari helps balance internal heat and hormones, which in turn helps promote healthy hair. | Reduces stress hormones and supports scalp nourishment, helping control stress-related hair fall.",
  },
  {
    product: "Hair Ras 09",
    productImage : "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/hair_ras09.webp?v=1773122932",
    productVariantId: "46464745308338",
    oneliner: "Hair Ras is customized to target internal root causes of your hair fall.",
    ingredientName: "Ashwagandha | Amalki",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Ashwagandha.webp?v=1770377173 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815",
    ingredientContent: "Ashwagandha helps reduce stress and encourages blood circulation in the scalp, thereby encouraging hair growth. | Boosts collagen synthesis and antioxidant protection, strengthening hair follicles at the root.",
  }
];

function updateRemovePopupContentByProduct(productName, productImage, selectedVariantId) {
  const normalizedName = productName.trim().toLowerCase();
  const matched = popOneLinerData.find(
    item => String(item.productVariantId) === String(selectedVariantId)
  );

  const allowedProductsRaw = [
    "pcos santulan", "pcos", "nourish oil", "Nourish hair oil",
    "thyroid santulan", "Thyro Santulan", "her santulan", "mom santulan",
    "Mom Santulan for Postpartum hair", "iron santulan", "her nourish",
    "hair ras 6", "Hair Ras 06", "hair santulan 1", "hair santulan 2",
    "hair santulan 3", "Hair Santulan 01", "Hair Santulan 02", "Hair Santulan 03",
    "health tatva", "gutt shuddhi", "digest boost",
    "Digest boost for Improved Digestive Ability", "calm ras", "hair ras",
    "nasal ghrit", "consti clear", "Consti Clear for Improved Bowel Movement",
    "scalp oil", "Scalp Oil 100ml with Dandruff Oil Shot",
    "Scalp Oil 100ml with Scalp Health Oil Shot",
    "Scalp Oil 100ml with Calm Oil Shot", "Scalp Oil 100ml with Growth Oil Shot",
  ];

  const allowedProducts = allowedProductsRaw.map(name => name.toLowerCase());
  const showDisclaimer = allowedProducts.some(name => normalizedName.includes(name));

  const disclaimerEl = document.querySelector('.remove-product-desclaimer');
  const disclaimerFlex = document.querySelector('.remove-product-desclaimer-flex');

  if (disclaimerEl && disclaimerFlex) {
    if (showDisclaimer) {
      disclaimerFlex.style.display = "flex";
      disclaimerEl.textContent = normalizedName.includes("hair vitamin for her")
        ? "Does not interfere with other medicines."
        : "100% Ayurvedic, does not interfere with other medicines.";
    } else {
      disclaimerFlex.style.display = "none";
    }
  }

  const titleElement = document.querySelector('.remove-popup-title');
  const imageElement = document.querySelector('.remove-popup-image');

  if (matched) {
    if (titleElement) titleElement.textContent = matched.oneliner;
    if (imageElement) imageElement.src = productImage || 'fallback.jpg';
  } else {
    if (titleElement) titleElement.textContent = "Are you sure you want to remove this item?";
    if (imageElement && productImage) imageElement.src = productImage;
  }
}

function languageSelection() {
  const languageIcon = document.getElementById("language-icon-faq");
  const languageDropdown = document.getElementById("language-dropdown");
  const languageOptions = document.querySelectorAll(".language-option-faq");
  const faqHinglishElements = document.querySelectorAll(".faq-question-answer.hinglish-faq");
  const faqEnglishElements = document.querySelectorAll(".faq-question-answer.english-faq");
  const wrapper = document.querySelector(".faq-hinglish-toggle--wrapper");
  const languageArrow = document.querySelector("#language-icon-faq .language-arrow");
  const languageText = document.querySelector("#language-icon-faq .language-icon-faq");

  languageIcon?.addEventListener("click", (e) => {
    e.stopPropagation();
    const isHidden = languageDropdown.classList.contains("hidden");

    languageDropdown.classList.toggle("hidden");
    wrapper.classList.toggle("hidden-dropdown");

    if (languageArrow) {
      languageArrow.classList.toggle("rotate", isHidden);
    }
  });

  languageOptions.forEach((option) => {
    option.addEventListener("click", (e) => {
      const selectedLang = e.target.getAttribute("hreflang");
      const languageSelected = e.target.getAttribute("lang");

      fireEvent("faq_toggle_clicked", caseId, languageSelected);

      languageOptions.forEach(opt => opt.classList.remove("active"));
      e.target.classList.add("active");

      languageText.textContent = selectedLang === "hi" ? "HI-EN" : "EN";

      if (selectedLang === "hi") {
        faqHinglishElements.forEach(el => el.classList.remove("d-none"));
        faqEnglishElements.forEach(el => el.classList.add("d-none"));
      } else {
        faqHinglishElements.forEach(el => el.classList.add("d-none"));
        faqEnglishElements.forEach(el => el.classList.remove("d-none"));
      }

      languageDropdown.classList.add("hidden");
      wrapper.classList.add("hidden-dropdown");

      if (languageArrow) {
        languageArrow.classList.remove("rotate");
      }
    });
  });

  document.addEventListener("click", (e) => {
    if (!languageIcon.contains(e.target) && !languageDropdown.contains(e.target)) {
      if (!languageDropdown.classList.contains("hidden")) {
        languageDropdown.classList.add("hidden");
        wrapper.classList.add("hidden-dropdown");
        if (languageArrow) {
          languageArrow.classList.remove("rotate");
        }
      }
    }
  });
  if (trayaProcessingAnimation) {
    trayaProcessingAnimation.style.display = 'none';
  }
  document.body.style.overflow = 'unset';
}

function fireExpectationEvent(eventName, caseID, selectedMonth) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "Number of the month clicked": selectedMonth,
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}
function initResultsTimeline(response) {
  function getTimelineData(response) {
    const resultsTimeline = {
      nonDandruff: [
        { month: "Month-1", heading: "Scalp health improves", 
          subheading: "Your scalp is being nourished & balanced, so it is ready for the solution.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_1_210cf616-1f58-421c-abc6-1bd173e735fc.webp?v=1774532597", 
          milestone: false
        },
        { month: "Month-2", heading: "Weak detached hair falls", 
          subheading: "New strong hair pushes old detached hair out of the root. You may notice some increased hairfall. It's part of the process and only lasts 4 weeks", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_2_b82bb5bc-5649-43a2-bb35-c3dee7d4ac7f.webp?v=1774532598", 
          milestone: false 
        },
        { month: "Month-3", heading: "Hair fall under Control", 
          subheading: "You notice less hairfall during combing, oiling, shampooing, as the new strong hair is strongly attached to the hair roots", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_3_beeece23-be55-4cde-b975-c44a17eedd2c.webp?v=1774532598", 
          milestone: true 
        },
        { month: "Month-4", heading: "Visible baby hair growth", 
          subheading: "Your visible scalp area starts to fill up with new baby hair.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_4_bec3c2a6-6ff3-45ec-bf59-b028ec61def4.webp?v=1774532597", 
          milestone: false 
        },
        { month: "Month-5", heading: "Fuller Scalp, Thicker Denser Hair", 
          subheading: "Your scalp starts feeling fuller as baby hair grows longer, which increases hair volume.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_5_1.webp?v=1774532597", 
          milestone: true },
        { month: "Traya for life", heading: "Healthy Hair - Strong from Root", 
          subheading: "Continue maintaining your hair with Traya serum and oil for continued results.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_6_e6471fae-da85-476d-afd0-ae99dec31e39.webp?v=1774532598",
          milestone: false 
        }
      ],
      dandruff: [
        { month: "Month-1", heading: "Visible dandruff reduction", 
          subheading: "Dandruff clears up so your scalp is cleaner and less irritated", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_0.webp?v=1770014538", 
          milestone: false 
        },
        { month: "Month-2", heading: "Scalp health improves further", 
          subheading: "Your scalp is being nourished & balanced, so it is ready for the treatment", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_1_210cf616-1f58-421c-abc6-1bd173e735fc.webp?v=1774532597", 
          milestone: false 
        },
        { month: "Month-3", heading: "Weak detached hair falls", 
          subheading: "New strong hair pushes old detached hair out of the root. You may notice some increased hairfall. It's part of the process and only lasts 4 weeks", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_2_b82bb5bc-5649-43a2-bb35-c3dee7d4ac7f.webp?v=1774532598", 
          milestone: false 
        },
        { month: "Month-4", heading: "Hair fall under control", 
          subheading: "You notice less hairfall during combing, oiling, shampooing, as the new strong hair is strongly attached to the hair roots", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_3_beeece23-be55-4cde-b975-c44a17eedd2c.webp?v=1774532598", 
          milestone: true 
        },
        { month: "Month-5", heading: "Baby Hair Growth", 
          subheading: "Your visible scalp area starts to fill up with new baby hair.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_4_bec3c2a6-6ff3-45ec-bf59-b028ec61def4.webp?v=1774532597", 
          milestone: false 
        },
        { month: "Month-6", heading: "Thick Dense Hair, Fuller Scalp", 
          subheading: "Your scalp starts feeling fuller as baby hair grows longer, which increases hair volume.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_5_1.webp?v=1774532597", 
          milestone: true 
        },
        { month: "Traya for life", heading: "Healthy Hair - Strong from Root", 
          subheading: "Continue maintaining your hair with Traya serum and oil for continued results.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_6_e6471fae-da85-476d-afd0-ae99dec31e39.webp?v=1774532598", 
          milestone: false 
        }
      ]
    };

    const defaultRC = response?.root_causes?.defaultRootCause || [];
    const primaryRC = response?.root_causes?.primaryRootCause || [];
    const allRootCauses = [...defaultRC, ...primaryRC];

    const hasDandruff = allRootCauses.some(rc =>
      rc?.key?.toLowerCase().includes("dandruff")
    );

    return hasDandruff
      ? resultsTimeline.dandruff
      : resultsTimeline.nonDandruff;
  }

  const monthEl = document.getElementById("rtpMonth");
  const titleEl = document.getElementById("rtpTitle");
  const descEl  = document.getElementById("rtpDesc");
  const curveEl = document.getElementById("rtpCurve");
  const imageBox = document.querySelector(".rtp-image-placeholder");
  const milestoneTextBox = document.querySelector(".rtp-milestone-achive-text");
  const milestoneNumberEl = document.getElementById("milestoneNumber");

  if (!monthEl || !titleEl || !descEl || !curveEl) return;

  const data = getTimelineData(response);
  
  // Get milestone indices and count
  const milestoneIndices = [];
  data.forEach((item, index) => {
    if (item.milestone) {
      milestoneIndices.push(index);
    }
  });

  // Auto-click state management
  let autoClickInterval = null;
  let currentIndex = 0;
  let isAutoClicking = true;
  let confettiShown = new Set(); // Track which milestones have shown confetti during auto-play
  let confettiTimeout = null; // Track confetti timeout

  function updateContent(index, isManualClick = false) {
    const item = data[index];
    const section = document.querySelector(".results-timeline-progress");
    const rtpContainer = document.querySelector(".rtp-container");

    monthEl.textContent = item.month;
    titleEl.textContent = item.heading;
    descEl.textContent  = item.subheading;

    if (item.image) {
      imageBox.src = item.image;
    }
    if (isManualClick) {
      fireExpectationEvent("expectation_setting_clicked_rp", caseId, `month-${index + 1}`);
    }
    // Update active node
    document.querySelectorAll(".rtp-node").forEach((el, i) => {
      el.classList.toggle("active", i === index);
    });

    document.querySelectorAll(".rtp-month-text").forEach((el, i) => {
      el.classList.toggle("show", i === index);
    });

    section.classList.remove("is-milestone");
    
    if (item.milestone && milestoneTextBox) {
      const milestoneNumber = milestoneIndices.indexOf(index) + 1;
      milestoneNumberEl.textContent = `Milestone #${milestoneNumber}`;
      milestoneTextBox.style.display = "flex";
      section.classList.add("is-milestone");

      // Show confetti logic:
      // - During auto-play: show only once per milestone
      // - On manual click: always show
      const shouldShowConfetti = isManualClick || !confettiShown.has(index);
      
      if (shouldShowConfetti) {
        // Track that we've shown this milestone during auto-play
        if (!isManualClick) {
          confettiShown.add(index);
        }
        
        // Clear any existing confetti timeout
        if (confettiTimeout) {
          clearTimeout(confettiTimeout);
        }
        
        // Remove existing confetti background
        rtpContainer.style.backgroundImage = 'none';
        
        // Trigger reflow to restart animation
        void rtpContainer.offsetWidth;
        
        // Add confetti background with cache-busting timestamp for manual clicks
        const confettiUrl = isManualClick 
          ? `url(https://cdn.shopify.com/s/files/1/0100/1622/7394/files/https___lottiefiles.com_animations_confetti-on-transparent-background-ajhx1TPBa7.gif?v=1770014641&t=${Date.now()})`
          : 'url(https://cdn.shopify.com/s/files/1/0100/1622/7394/files/https___lottiefiles.com_animations_confetti-on-transparent-background-ajhx1TPBa7.gif?v=1770014641)';
        
        rtpContainer.style.backgroundImage = confettiUrl;
        
        // Remove confetti after animation completes
        confettiTimeout = setTimeout(() => {
          rtpContainer.style.backgroundImage = 'none';
        }, 1200);
      }
    } else {
      milestoneTextBox.style.display = "none";
    }

    currentIndex = index;
  }

  function startAutoClick() {
    if (autoClickInterval) {
      clearInterval(autoClickInterval);
    }

    autoClickInterval = setInterval(() => {
      if (!isAutoClicking) {
        clearInterval(autoClickInterval);
        return;
      }

      currentIndex = (currentIndex + 1) % data.length;
      
      // Reset confetti tracking when loop starts over (back to index 0)
      if (currentIndex === 0) {
        confettiShown.clear();
      }
      
      updateContent(currentIndex);
    }, 3000);
  }

  function stopAutoClick() {
    isAutoClicking = false;
    if (autoClickInterval) {
      clearInterval(autoClickInterval);
      autoClickInterval = null;
    }
  }

  function renderTimeline() {
    curveEl.innerHTML = "";

    data.forEach((item, index) => {
      const nodeContainer = document.createElement("div");
      nodeContainer.style.position = "absolute";
      nodeContainer.style.bottom = "0";
      
      const node = document.createElement("div");
      node.className = "rtp-node"; 
      node.textContent = index + 1;

      if (item.milestone) {
        const flag = document.createElement("span");
        flag.className = "rtp-flag";
        flag.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/https___lottiefiles.com_animations_flag-animation-Y9v5xnRs1p.gif?v=1770014631" class="rtp-milestone-flag" width="auto" height="auto" alt="Milestone Flag">`;
        node.appendChild(flag);
      }

      const monthText = document.createElement("span");
      monthText.className = "rtp-month-text";
      monthText.textContent = "MONTH";
      node.appendChild(monthText);
      
      node.addEventListener("click", () => {
        stopAutoClick(); // Stop auto-clicking when user clicks
        updateContent(index, true); // Pass true to indicate manual click
      });
      
      nodeContainer.appendChild(node);
      curveEl.appendChild(nodeContainer);
    });

    updateContent(0);
    // Auto-click will be started by Intersection Observer when section is in viewport
  }

  function positionNodesOnArc() {
    const nodes = document.querySelectorAll(".rtp-node");
    const total = nodes.length;
    const isMobile = window.innerWidth <= 767;

    if (isMobile) {
      if (total === 6) {
        const mobilePositions = [
          { left: 9,  bottom: 34 },
          { left: 24, bottom: 55 },
          { left: 41, bottom: 67 },
          { left: 59, bottom: 67 },
          { left: 76, bottom: 56 },
          { left: 91, bottom: 30 }
        ];

        nodes.forEach((node, index) => {
          if (!mobilePositions[index]) return;
          node.parentElement.style.left = mobilePositions[index].left + "%";
          node.parentElement.style.bottom = mobilePositions[index].bottom + "px";
        });
      } else if (total === 7) {
        const mobilePositions7 = [
          { left: 7,  bottom: 28 },
          { left: 20, bottom: 48 },
          { left: 34, bottom: 60 },
          { left: 50, bottom: 66 },
          { left: 66, bottom: 60 },
          { left: 80, bottom: 48 },
          { left: 93, bottom: 28 }
        ];

        nodes.forEach((node, index) => {
          if (!mobilePositions7[index]) return;
          node.parentElement.style.left = mobilePositions7[index].left + "%";
          node.parentElement.style.bottom = mobilePositions7[index].bottom + "px";
        });
      }

      return;
    }

    const startX = 10;
    const endX   = 90;
    const minY   = 12;
    const maxY   = 100;

    nodes.forEach((node, index) => {
      const t = index / (total - 1);
      const x = startX + (endX - startX) * t;
      const y = minY + (4 * maxY * t * (1 - t));

      node.parentElement.style.left = x + "%";
      node.parentElement.style.bottom = y + "px";
    });

    if (total === 6) {
      nodes[0].parentElement.style.left = "11%";
      nodes[0].parentElement.style.bottom = "24px";
      nodes[total - 1].parentElement.style.left = "89%";
      nodes[total - 1].parentElement.style.bottom = "24px";
    } else if (total === 7) {
      nodes[0].parentElement.style.left = "10%";
      nodes[0].parentElement.style.bottom = "20px";
      nodes[total - 1].parentElement.style.left = "90%";
      nodes[total - 1].parentElement.style.bottom = "20px";
    }
  }

  renderTimeline();
  positionNodesOnArc();
  window.addEventListener("resize", () => {
    positionNodesOnArc();
  });

  // Intersection Observer to start auto-click when section is in viewport
  const section = document.querySelector(".results-timeline-progress");
  if (section) {
    const observerOptions = {
      root: null, // viewport
      rootMargin: '0px',
      threshold: 0.3 // Trigger when 30% of the section is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && isAutoClicking) {
          // Section is in viewport, start auto-clicking
          startAutoClick();
        } else if (!entry.isIntersecting && autoClickInterval) {
          // Section is out of viewport, pause auto-clicking
          clearInterval(autoClickInterval);
          autoClickInterval = null;
        }
      });
    }, observerOptions);

    observer.observe(section);
  }
}
function getTimelineData(response) {
  // ----------------------------------------
  // 1. Full timeline dataset
  // ----------------------------------------
  const resultsTimeline = {
    nonDandruff: [
      {
        month: "Month 1",
        heading: "Scalp health improves",
        subheading:
          "Your scalp is being nourished & balanced, so it is ready for the solution.",
        milestone: false
      },
      {
        month: "Month 2",
        heading: "Weak detached hair falls",
        subheading:
          "New strong hair pushes old detached hair out of the root. You may notice some increased hairfall. It's part of the process and only lasts 4 weeks",
        milestone: false
      },
      {
        month: "Month 3",
        heading: "Hair fall under Control",
        subheading:
          "You notice less hairfall during combing, oiling, shampooing, as the new strong hair is strongly attached to the hair roots",
        milestone: true
      },
      {
        month: "Month 4",
        heading: "Faster Hair Growth",
        subheading:
          "Your hair grows at a healthy speed and starts feeling softer & smoother.",
        milestone: false
      },
      {
        month: "Month 5",
        heading: "Thick Dense Hair, Fuller Scalp",
        subheading:
          "Your scalp starts feeling fuller as hairfall is less & hair growth is fast",
        milestone: true
      },
      {
        month: '"Traya for life"',
        heading: "Healthy Hair - Strong from Root",
        subheading:
          "Continue maintaining your hair with Traya serum and oil for continued results.",
        milestone: false
      }
    ],

    dandruff: [
      {
        month: "Month 1",
        heading: "Visible dandruff reduction",
        subheading:
          "Dandruff clears up so your scalp is cleaner and less irritated",
        milestone: false
      },
      {
        month: "Month 2",
        heading: "Scalp health improves further",
        subheading:
          "Your scalp is being nourished & balanced, so it is ready for the treatment",
        milestone: false
      },
      {
        month: "Month 3",
        heading: "Weak detached hair falls",
        subheading:
          "New strong hair pushes old detached hair out of the root. You may notice some increased hairfall. It's part of the process and only lasts 4 weeks",
        milestone: false
      },
      {
        month: "Month 4",
        heading: "Hair fall under control",
        subheading:
          "You notice less hairfall during combing, oiling, shampooing, as the new strong hair is strongly attached to the hair roots",
        milestone: true
      },
      {
        month: "Month 5",
        heading: "Faster Hair Growth",
        subheading:
          "Your hair grows at a healthy speed and starts feeling softer & smoother.",
        milestone: false
      },
      {
        month: "Month 6",
        heading: "Thick Dense Hair, Fuller Scalp",
        subheading:
          "Your scalp starts feeling fuller as hairfall is less & hair growth is fast",
        milestone: true
      },
      {
        month: '"Traya for life"',
        heading: "Healthy Hair - Strong from Root",
        subheading:
          "Continue maintaining your hair with Traya serum and oil for continued results.",
        milestone: false
      }
    ]
  };

  // ----------------------------------------
  // Correct root cause extraction
  // ----------------------------------------
  const defaultRC = response?.root_causes?.defaultRootCause || [];
  const primaryRC = response?.root_causes?.primaryRootCause || [];

  const allRootCauses = [...defaultRC, ...primaryRC];

  console.log("ALL ROOT CAUSES:", allRootCauses);

  // ----------------------------------------
  // Dandruff detection
  // ----------------------------------------
  const hasDandruff = allRootCauses.some(rc =>
    rc?.key?.toLowerCase().includes("dandruff")
  );

  console.log("HAS DANDRUFF?", hasDandruff);

  return hasDandruff
    ? resultsTimeline.dandruff
    : resultsTimeline.nonDandruff;
}

function renderTimeline(timelineData, containerSelector) {
  const container = document.querySelector(containerSelector);
  if (!container) {
    console.warn("Timeline container not found:", containerSelector);
    return;
  }

  container.innerHTML = ""; // Clear previous content

  let milestoneCounter = 1;

  timelineData.forEach((item, index) => {

    let milestoneHTML = "";
    if (item.milestone) {
      milestoneHTML = `
        <div class="rt-milestone-felxer">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2.66699 9.1663C2.66699 9.1663 3.33366 8.49963 5.33366 8.49963C7.33366 8.49963 8.66699 9.83297 10.667 9.83297C12.667 9.83297 13.3337 9.1663 13.3337 9.1663V1.99967C13.3337 1.99967 12.667 2.66634 10.667 2.66634C8.66699 2.66634 7.33366 1.33301 5.33366 1.33301C3.33366 1.33301 2.66699 1.99967 2.66699 1.99967V9.1663Z" fill="white" stroke="#F0F0F0" stroke-width="1.2"/>
            <path d="M2.66699 14.6667V9" stroke="#F0F0F0" stroke-width="1.2"/>
          </svg>
          <span class="rt-milestone">Milestone #${milestoneCounter}</span>
        </div>
      `;
      milestoneCounter++;
    }

    const card = `
      <div class="rt-item">
        <div class="rt-dot-line">
          <span class="rt-dot"></span>
          ${index !== timelineData.length - 1 ? `<span class="rt-line"></span>` : ""}
        </div>

        <div class="rt-content">
          <p class="rt-month">${item.month}</p>
          <h3 class="rt-heading rt-truncate">${item.heading}</h3>
          <p class="rt-subheading rt-truncate">${item.subheading}</p>

          ${milestoneHTML}
        </div>
      </div>
    `;

    container.insertAdjacentHTML("beforeend", card);
  });

  // ⭐ APPLY SLICK ONLY ON DESKTOP
  setTimeout(() => {
    if (window.innerWidth > 768) {
      if (!$(container).hasClass("slick-initialized")) {
        $(container).slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
          dots: false,
          infinite: false,
          pauseOnHover: false,
        })
        .on("afterChange", function (event, slick, currentSlide) {
          const lastSlide = slick.slideCount - slick.options.slidesToShow;

          if (currentSlide >= lastSlide) {
            // wait for autoplay delay, then restart from beginning
            setTimeout(() => {
              $(this).slick("slickGoTo", 0);
            }, slick.options.autoplaySpeed);
          }
        });

      }
    } else {
      // Mobile → destroy slick if it exists
      if ($(container).hasClass("slick-initialized")) {
        $(container).slick("unslick");
      }
    }
  }, 50); // small delay to ensure items are rendered
}

// timeline section 
function sectionMonthsExpectetion(response) {
  let { monthsExpectation } = response;
  if (monthsExpectation.monthExpectations && monthsExpectation.showComponent == true) {
    const timeline = document.getElementById('timeline');

    // ── OPTIMIZATION: build all timeline blocks in a DocumentFragment (1 reflow) ──
    const fragment = document.createDocumentFragment();
    monthsExpectation.monthExpectations.forEach((month, index) => {
        const block = document.createElement('div');
        block.className = 'timeline-block';
        block.innerHTML = `
            <div class="timeline-icon">
              <img src="${month.image_url}" alt="Month ${month.month}"  width="100px" height="100px" loading="lazy">
            </div>
            ${index < monthsExpectation.monthExpectations.length - 0 ? `
              <div class="timeline-dot-line">
                <div class="timeline-dot"></div>
                <div class="timeline-line"></div>
              </div>
            ` : ''}
            <div class="timeline-content">
              <p><strong>Month ${month.month}</strong></p>
              <p class="monthe-suggestion">${month.goal}</p>
            </div>
        `;
       fragment.appendChild(block);
    });
    timeline.appendChild(fragment);   // single DOM write
    // ── END OPTIMIZATION ──

    if (timeline && typeof $.fn.slick === "function") {
      $(timeline).slick({
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
      });
      if ($(window).width() < 768) {
        $(timeline).slick('unslick');
      }
      if (monthsExpectation.monthExpectations.length <= 4) {
        timeline.classList.add('minus-the-margin');
        $(timeline).slick('unslick');
      }
    }
  }
}
// timeline section end

// custom price 
function customPriceSection(response) {
  let cartPrice = response.cart_price;
  cartPrice = parseFloat(cartPrice).toFixed(2);
  if (cartPrice.endsWith('.00')) {
    cartPrice = parseInt(cartPrice);
  }
  
  const dynamicPriceElements = document.querySelectorAll('#dynamic-price');
  if (dynamicPriceElements.length > 0) {
    dynamicPriceElements.forEach(element => {
      element.innerHTML = cartPrice;
    });
  } else {
    console.error('Price elements not found');
  }
}
// end of custom price

// doctor recomandation section 
function sectionBlocksDisplay(response) {
  let { User_Analysis } = response;
  let stage = User_Analysis.hair_fall_stage;
  const apiSection = document.querySelector('.static-block-container');
  const staticSection = document.querySelector('.block-container');

  const isDesktop = window.matchMedia('(min-width: 768px)').matches;

  if (stage == "No widening" || stage == "Starting to see widening") {
    apiSection.style.display = 'none';
    staticSection.style.display = isDesktop ? 'flex' : 'block';
  } else {
    apiSection.style.display = isDesktop ? 'flex' : 'block';
    staticSection.style.display = 'none';
  }
}
// doctor recomandation section end

// women's stories section function
function sectionWomensStories(response) {
  let { successStories } = response;
  if (successStories.stories && successStories.showComponent == true) {
    const imgCarousel = document.querySelector('.image-carousel');
    const titleElement = document.querySelector('.stories-main-heading');

    titleElement.textContent = 'Real Women, Real Stories';

    successStories.stories.forEach((storyUrl) => {        
      const imgCarouselBlock = document.createElement('div');
      imgCarouselBlock.className = 'image-carousel-container';
      imgCarouselBlock.innerHTML = `
        <div class="image-carousel--container-img position-relative mx-2">
          <img src="${storyUrl}" alt="Success Story" height="auto" width="auto" loading="lazy" >
        </div>
      `;
      imgCarousel.appendChild(imgCarouselBlock);
    });

    $(imgCarousel).slick({
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false, 
      dots: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "15px",
            dots: true,
          },
        },
      ],
    });
  }
}
// women's stories section function end

// Function to determine if the device is mobile
function isMobileDevice() {
  return window.innerWidth <= 767;
}

// Function to create and display popup with product details
function createProductPopup(productId) {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  const popupContentPlaceholder = document.getElementById('popup-content-placeholder');
  const siteUrl = {
    dev: { 
      "Link": "formv2s.dev.hav-g.in"
    },
    prod: { 
      "Link": "form.traya.health"
    }
  };
  console.log(caseId, 'its that caseid');
  let iframeUrl = `https://${siteUrl.prod.Link}/product-drawerv2/${productId}`;
  if (/^[0-7]/.test(caseId)) {
    iframeUrl += '?price=hide';
  }
  popupContentPlaceholder.innerHTML = `
    <iframe src="${iframeUrl}" frameborder="0" width="100%" height="100%"></iframe>
  `;
  
  if (isMobileDevice()) {
    popup.style.bottom = '0';
  } else {
    popup.style.right = '0';
  }

  overlay.style.display = 'block';
  document.body.style.overflow = 'hidden';
  const closeIcon = document.getElementById('close-popup');
  closeIcon.addEventListener('click', function() {
    closeProductPopup();
  });
  overlay.addEventListener('click', function() {
    closeProductPopup();
  });
}

// Function to close the popup
function closeProductPopup() {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  
  if (isMobileDevice()) {
    popup.style.bottom = '-100%';
  } else {
    popup.style.right = '-100%';
  }

  overlay.style.display = 'none';
  document.body.style.overflow = '';
}

// Event delegation to handle click on product cards
document.querySelector('.product-combo-details').addEventListener('click', function(event) {
  if (event.target.closest('.product-remove-btn')) {
    return;
  }
  const reco = event.target.closest('.kit-card-container');
  if (reco) {
    const productId = reco.getAttribute('data-product-id');
    const productName = reco.getAttribute('data-product-name');
    productFireEvent("web_product_card_clicked", caseId, productName);
    createProductPopup(productId);
  }
});

function clearCart() {
  $.getJSON('/cart.js', function(cart) {
    if (cart.item_count === 0) { silentCheckout(); return; }
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      dataType: 'json',
      success: function() {
        silentCheckout();
      },
      error: function(error) {
        console.error('Error on first clear:', error);
      }
    });
  });
}

function silentCheckout() {
  let buyButtonElement = document.querySelectorAll('#add-to-cart-result-page-frp');
  buyButtonElement.forEach((eachBtn) => {
    eachBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_clockwise.svg?v=1746524502" class="loader-icon" alt="Loading...">`;
    eachBtn.classList.add('loader-added')
    eachBtn.disabled = true;
  })
  localStorage.setItem('user__gender', user_gender);
  localStorage.setItem('caseId', caseId);
  if(user__gender == 'F') {
    user_gender = 'Female';
  }
  variantsIDs.forEach(e => {
    e.properties = { 'Plan': 'Auto' };
  });

  const formData = {
    items: variantsIDs,
    attributes: {
      first_name: f_name,
      phone: C_number,
      email: C_email,
      caseid: caseId,
      user__gender: user_gender,
      userHairStage: hairStage
    }
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(result => {
    localStorage.setItem('User_location', 'cart');
    console.log("Silent checkout complete");    
  })
  .catch(error => {
    console.error('Silent checkout error:', error);
  })
  .finally(() => {
    removeLoader();       
    updateCartDrawer();
  });
}
// ── END OPTIMIZATION ──

async function ATCFunction() {
  // Fetch cart state first to avoid calling clear.js on an already-empty cart.
  // Excessive clear.js calls on empty carts trigger Cloudflare bot detection on Shopify's CDN.
  try {
    const cartState = await fetch('/cart.js').then(r => r.json());
    if ((cartState.item_count || 0) > 0) {
      await fetch('/cart/clear.js', { method: 'POST' }).then(r => r.json());
    }
  } catch (error) {
    console.error('Clear Cart Error: ', error);
  } finally {
    checkout();
    const addToCartEvent = 'result_add_to_cart';
    const addToCartEventData = { "gender": "Female"};
    Shopify.analytics.publish(addToCartEvent, addToCartEventData);
  }
}

(function () {
  const utmParams = ['utm_source', 'utm_campaign', 'utm_medium'];
  const urlParams = new URLSearchParams(window.location.search);
  utmParams.forEach(param => {
    const val = urlParams.get(param);
    if (val) localStorage.setItem(param, val);
  });
  const attributes = {};
  utmParams.forEach(param => {
    const val = localStorage.getItem(param);
    if (val) attributes[param] = val;
  });

  if (Object.keys(attributes).length === 0) return;

  function updateWhenCartIsReady() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(data => {
        if (data.items.length > 0) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes })
          })
            .then(res => res.json())
            .then(() => {
              console.log('Cart attributes updated:', attributes);
            })
            .catch(err => {
              console.error('Failed to update cart:', err);
            });
        } else {
          console.log('Cart empty, retrying...');
          setTimeout(updateWhenCartIsReady, 1000);
        }
      });
  }
  updateWhenCartIsReady();
})();

window.addEventListener('DOMContentLoaded', function() {
  var stickyBtn = document.querySelector('[sticky__btn]');

  if (stickyBtn) {
    stickyBtn.style.display = 'block';
    stickyBtn.style.position = 'fixed';
    stickyBtn.style.bottom = '0';
    stickyBtn.style.right = '0';
  }
  
  var stickyBtn = document.querySelector('[btn_sticky]');

  if (stickyBtn) {
    stickyBtn.style.display = 'block';
    stickyBtn.style.position = 'fixed';
    stickyBtn.style.bottom = '0';
    stickyBtn.style.right = '0';
  }
  const stickyButton = document.querySelector('.template-page.female-result [sticky__btn]');
  const stickyButtonCuticle = document.querySelector('.template-page.female-result [btn_sticky]');
  const addToCartButton = document.getElementById('add-to-cart-result-page-frp');
  
  const addZIndex = (element) => {
    if (element) {
      element.style.zIndex = '9999';
    }
  };

  const removeZIndex = (element) => {
    if (element) {
      element.style.zIndex = '';
    }
  };

  const handleAddToCartClick = () => {
    if (window.matchMedia("(min-width: 768px)").matches) {
      if (stickyButton && stickyButton.style.zIndex === '9999') {
        removeZIndex(stickyButton);
      } else {
        addZIndex(stickyButton);
      }
    }
  };

  if (window.matchMedia("(min-width: 768px)").matches) {
    addZIndex(stickyButton);
  }

  if (addToCartButton) {
    addToCartButton.addEventListener('click', function() {
      handleAddToCartClick();
    });
  }
  
  window.addEventListener('resize', () => {
    if (window.matchMedia("(min-width: 768px)").matches) {
      addZIndex(stickyButton);
    } else {
      removeZIndex(stickyButton);
    }
  });
});

function initBannerPopup() {
  const bannerLink = document.querySelector('.traya-banner-link');
  bannerLink.classList.remove('d-none')
  if (!document.getElementById('bp-popup')) {
    document.body.insertAdjacentHTML('beforeend', `
      <style>
        #bp-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,.55); z-index:10000; }
        #bp-popup {
          position: fixed;
          background: #fff;
          z-index: 99999;;
          overflow-y: auto;
          opacity: 0;
          transition: transform 0.35s ease, opacity 0.35s ease;
        }

        /* Desktop — centered modal */
        @media (min-width: 768px) {
          #bp-popup {
            top: 50%; left: 50%;
            width: 812px;
            max-height: 85vh;
            border-radius: 16px;
            transform: translate(-50%, -50%) scale(0.85);
          }
          #bp-popup.bp-open {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
          }
        }

        /* Mobile — bottom sheet */
        @media (max-width: 767px) {
          #bp-popup {
            left: 0; right: 0; bottom: 0;
            max-height: 75vh;
            border-radius: 16px 16px 0 0;
            transform: translateY(100%);
          }
          #bp-popup.bp-open {
            transform: translateY(0);
            opacity: 1;
          }
        }
      </style>
      <div id="bp-overlay"></div>
      <div id="bp-popup">
        <div style="position:sticky;top:0;height:0;z-index:3;pointer-events:none;">
          <div style="position:absolute;top:8px;left:0;right:0;display:flex;justify-content:center;"><span style="width:72px;height:4px;flex-shrink:0;border-radius:100px;background:#DEDEDE;"></span></div>
          <button id="bp-close" aria-label="Close" style="position:absolute;top:12px;right:16px;pointer-events:auto;display:flex;width:32px;height:32px;padding:0;justify-content:center;align-items:center;gap:10px;border-radius:999px;opacity:0.8;background:#FFF;border:none;cursor:pointer;flex-shrink:0;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M12 4L4 12M4 4L12 12" stroke="#262626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <div id="bp-content" style="padding:0"></div>
      </div>
    `);
  }

  const overlay = document.getElementById('bp-overlay');
  const popup   = document.getElementById('bp-popup');
  const content = document.getElementById('bp-content');
  let cache        = null;
  let fetchPromise = null;

  function ensureSlickCSS() {
    ['slick.css', 'slick-theme.css'].forEach(function(f) {
      const href = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/' + f;
      if (!document.querySelector('link[href="' + href + '"]')) {
        const link = document.createElement('link');
        link.rel  = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    });
  }

  function load() {
    if (fetchPromise) return fetchPromise;
    fetchPromise = fetch('copy-of-hair-growth-science')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (!document.getElementById('bp-styles')) {
          const wrap = document.createElement('div');
          wrap.id = 'bp-styles';
          doc.querySelectorAll('head style').forEach(function(s) {
            const st = document.createElement('style');
            st.textContent = s.textContent;
            wrap.appendChild(st);
          });
          document.head.appendChild(wrap);
        }
        cache = (doc.querySelector('main') || doc.body).innerHTML;
        // ✅ No render() here — scripts only run when popup is actually opened
        return cache;
      })
      .catch(function(err) { console.error('BP fetch failed:', err); fetchPromise = null; });
  }

  function render() {
    content.innerHTML = cache;
    content.querySelectorAll('script').forEach(function(old) {
      if (old.textContent.indexOf('cs-slider') > -1) return;
      const s = document.createElement('script');
      if (old.src) { s.src = old.src; s.async = false; }
      else { s.textContent = old.textContent; }
      document.body.appendChild(s);
    });
    ensureSlickCSS();
    waitAndInitCSSlider();
  }

  function waitAndInitCSSlider() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      setTimeout(waitAndInitCSSlider, 100);
      return;
    }
    setTimeout(function() {
      const $s = jQuery('#bp-popup .cs-slider');
      if (!$s.length) { console.warn('BP: .cs-slider not found in popup'); return; }
      if ($s.hasClass('slick-initialized')) { $s.slick('unslick'); }
      const $dots  = jQuery('#bp-popup .cs-dots');
      const $label = jQuery('#bp-popup .cs-dot-label');
      $s.slick({
        slidesToShow: 2.2, slidesToScroll: 1, centerMode: false,
        dots: false, arrows: false,
        infinite: false, autoplay: true, autoplaySpeed: 2500, speed: 600,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 2.2, centerMode: false } },
          { breakpoint: 768,  settings: { slidesToShow: 1.2, centerMode: false } }
        ]
      });
      const total = $s.slick('getSlick').slideCount;
      $dots.empty();
      for (var _d = 0; _d < total; _d++) {
        jQuery('<button type="button" class="cs-mdot" aria-label="Go to slide ' + (_d + 1) + '"></button>')
          .toggleClass('is-active', _d === 0)
          .appendTo($dots);
      }
      $dots.on('click', '.cs-mdot', function() { $s.slick('slickGoTo', jQuery(this).index()); });
      if ($label.length) $label.text('1 / ' + total);
      $s.on('afterChange', function(e, slick, i) {
        $dots.find('.cs-mdot').removeClass('is-active').eq(i).addClass('is-active');
        if ($label.length) $label.text((i + 1) + ' / ' + slick.slideCount);
      });
      console.log('BP: CS slider initialised with', total, 'slides');
    }, 200);
  }

  function open() {
    overlay.style.display        = 'block';
    popup.style.display          = 'block';
    document.body.style.overflow = 'hidden';
    popup.scrollTop              = 0;
    requestAnimationFrame(() => popup.classList.add('bp-open'));
    // ✅ Always goes through load() — resolves instantly if already cached
      // ✅ Prefetch HTML only — no script injection on page load
    chatIconClicked("hair_science_component_click", caseId);
    load().then(() => render());
  }

  function close() {
    popup.classList.remove('bp-open');
    setTimeout(function() {
      overlay.style.display = 'none';
      popup.style.display   = 'none';
    }, 350);
    document.body.style.overflow = '';
  }

  bannerLink.addEventListener('click', function(e) { e.preventDefault(); open(); });
  document.getElementById('bp-close').addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });


  load();
}

function trayaComparisonSection(response) {
  const isValidCase = caseId && /^[0-4]/.test(caseId);
  const comparisonSection = document.querySelector('.traya-comparison');
  if (!comparisonSection) return;

  if (!isValidCase) {
    comparisonSection.classList.add('d-none');
    return;
  }

  comparisonSection.classList.remove('d-none');

  const cartPrice = Math.round(response.cart_price);
  const priceRow = comparisonSection.querySelector('.traya-comparison__row-traya--price');
  if (priceRow) {
    priceRow.innerHTML = `₹${cartPrice.toLocaleString('en-IN')}`;
  }
}

function visualFaq(response) {
  const visualFaqEl = document.querySelector('.faq-traya');
  const revampFaqEl = document.querySelector('[class*="f-reault-page-revamp-faq"]');

  // Compute D+ vs D0 from the form fill date
  let formFillDateStr = response?.User_Analysis?.case_created_date;
  let formFillDate = new Date(formFillDateStr);
  if (isNaN(formFillDate.getTime())) {
    formFillDateStr = getCookie('current_D0_date');
    formFillDate = new Date(formFillDateStr);
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // D+ (form filled on a previous day) → visual FAQ
  // D0 (form filled today) or unknown date → revamp FAQ
  const isDPlus = !isNaN(formFillDate.getTime()) && formFillDate < today;
  const showVisual = isDPlus;

  if (visualFaqEl) visualFaqEl.style.display = showVisual ? 'block' : 'none';
  if (revampFaqEl) revampFaqEl.style.display = showVisual ? 'none'  : 'block';

  const activeFaqEl = showVisual ? visualFaqEl : revampFaqEl;
  if (!activeFaqEl) return;

  activeFaqEl.querySelectorAll('[data-faq-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item    = btn.closest('[data-faq-item]');
      const faqName = item?.querySelector('[data-faq-trigger] span')?.textContent?.trim() || 'unknown';
      productFireEvent("web_visual_faq_clicked", caseId, faqName);
    });
  });
}

function setupTrayaForeverFaq(caseId, response) {
  const trayaFaqSection = document.querySelector('.traya-faq');
  if (!trayaFaqSection) return;

  const validCase = caseId && /^[0-7]/.test(String(caseId));
  if (!validCase) {
    trayaFaqSection.style.display = 'none';
    return;
  }

  // Show only for D0 users (form filled today). Hide for D+ users.
  let formFillDateStr = response?.User_Analysis?.case_created_date;
  let formFillDate = new Date(formFillDateStr);
  if (isNaN(formFillDate.getTime())) {
    formFillDateStr = getCookie('current_D0_date');
    formFillDate = new Date(formFillDateStr);
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const isDPlus = !isNaN(formFillDate.getTime()) && formFillDate < today;
  if (isDPlus) {
    trayaFaqSection.style.display = 'none';
    return;
  }

  trayaFaqSection.style.display = '';

  // Dynamically swap the center maintenance kit image if Minoxidil or
  // Hair Active Serum is recommended in the user's kit.
  updateMaintenanceKitImages(trayaFaqSection, response);

  // Place FAQ directly after .product-combo-details
  const productComboContainer = document.querySelector('.combined-cart-price-wrapper');
  if (productComboContainer && productComboContainer.nextElementSibling !== trayaFaqSection) {
    productComboContainer.insertAdjacentElement('afterend', trayaFaqSection);
  }

  const trigger = trayaFaqSection.querySelector('[data-popup-open]');
  if (!trigger) return;

  if (trigger.dataset.trayaForeverBound === 'true') return;
  trigger.dataset.trayaForeverBound = 'true';

  trigger.addEventListener('click', () => {
    const syntheticId =
      window.location.search.substring(1).split('=')[1] || 'default-id';
    fireTrayaForeverEvent('web_traya_forever_clicked', caseId, syntheticId);
  });
}
function updateMaintenanceKitImages(trayaFaqSection, response) {
  // ─── DEBUG: D0/D+ scale toggle for widening stages ─────────────────────
  const wideningStages = [
    'no widening',
    'starting to see widening',
    'medium widening',
    'advanced widening'
  ];
  const stage = (userHairStage || '').toLowerCase();
  const isWidening = wideningStages.includes(stage);

  // Read both possible date sources
  const apiDateStr = response?.User_Analysis?.case_created_date;
  const cookieDateStr = getCookie('current_D0_date');

  let formFillDate = apiDateStr ? new Date(apiDateStr) : null;
  let dateSource = 'api'; 
  if (!formFillDate || isNaN(formFillDate.getTime())) {
    formFillDate = cookieDateStr ? new Date(cookieDateStr) : null;
    dateSource = 'cookie';
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const isDPlus =
    formFillDate &&
    !isNaN(formFillDate.getTime()) &&
    formFillDate < today;

  if (isWidening) {
    if (!isDPlus) {
      trayaFaqSection.classList.add('traya-faq--scaled-up');
    } else {
      trayaFaqSection.classList.remove('traya-faq--scaled-up');
    }
  } else {
    trayaFaqSection.classList.remove('traya-faq--scaled-up');
  }

  console.log('[trayaFaq DEBUG] section classes AFTER:', trayaFaqSection.className);

  // ─── Existing image-swap logic below (unchanged) ───────────────────────
  const sectionId = trayaFaqSection.dataset.sectionId;
  const popup = sectionId
    ? document.getElementById(`TrayaFaqPopup-${sectionId}`)
    : null;

  const productsContainer =
    (popup && popup.querySelector('.traya-faq__products')) ||
    trayaFaqSection.querySelector('.traya-faq__products');

  if (!productsContainer) return;

  const swappableProduct = productsContainer.querySelector(
    '[data-alternate-image], [data-alternate-image-hair-active]'
  );
  if (!swappableProduct) return;

  const kitContainer = document.querySelector('.product-combo-details');
  if (!kitContainer) return;

  const kitCards = kitContainer.querySelectorAll('.kit-card-container');
  const kitNames = Array.from(kitCards).map(card =>
    (card.dataset.productName || '').toLowerCase()
  );

  const hasMinoxidil  = kitNames.some(name => name.includes('minoxidil'));
  const hasHairActive = kitNames.some(name => name.includes('hair active'));

  let alternateSrc = null;
  let alternateAlt = null;

  if (hasMinoxidil && swappableProduct.dataset.alternateImage) {
    alternateSrc = swappableProduct.dataset.alternateImage;
    alternateAlt = swappableProduct.dataset.alternateAlt || 'Minoxidil';
  } else if (hasHairActive && swappableProduct.dataset.alternateImageHairActive) {
    alternateSrc = swappableProduct.dataset.alternateImageHairActive;
    alternateAlt = swappableProduct.dataset.alternateAltHairActive || 'Hair Active Serum';
  }

  if (!alternateSrc) return;

  let img = swappableProduct.querySelector('img');
  if (!img) {
    const placeholder = swappableProduct.querySelector('.traya-faq__product-placeholder');
    if (placeholder) placeholder.remove();
    img = document.createElement('img');
    img.className = 'traya-faq__product-img';
    img.loading = 'lazy';
    swappableProduct.appendChild(img);
  }

  img.src = alternateSrc;
  img.alt = alternateAlt;
  img.removeAttribute('srcset');
  img.removeAttribute('sizes');
}

// ============================================================
// Seema Story prefetch + cache
// ============================================================
let seemaStoryCache = null;
let seemaStoryFetchPromise = null;

function prefetchSeemaStory() {
  if (seemaStoryCache || seemaStoryFetchPromise) return seemaStoryFetchPromise;

  seemaStoryFetchPromise = fetch('/pages/hair-journey-story')
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const main =
        doc.querySelector('main') ||
        doc.querySelector('#MainContent') ||
        doc.querySelector('.page-width') ||
        doc.querySelector('.shopify-section') ||
        doc.body;
      seemaStoryCache = main.cloneNode(true);
      return seemaStoryCache;
    })
    .catch(err => {
      console.error('Failed to prefetch Seema story:', err);
      seemaStoryFetchPromise = null;
      throw err;
    });

  return seemaStoryFetchPromise;
}
function setupSomeoneLikeYou(response) {
  const slySection = document.querySelector('[data-someone-like-you]');

  const hairFallStage = response?.User_Analysis?.hair_fall_stage;
  const isCoinSizePatch = /alopecia\s*areata/i.test(hairFallStage || '');
  console.log('[SLY]', { hairFallStage, isCoinSizePatch, slyFound: !!slySection });
   // Reset height so the section sizes to its content (fixes coin size patch overflow)
  const stageReportSection = document.querySelector('.female-test-report-section');
  if (stageReportSection) {
    stageReportSection.style.height = 'auto';
    stageReportSection.style.minHeight = '0';
  }

 if (isCoinSizePatch) {
  if (slySection) {
    slySection.classList.add('d-none');
    slySection.style.display = 'none';

    const slyWrapper =
      slySection.closest('section, .shopify-section') ||
      slySection.parentElement;
    if (slyWrapper && slyWrapper !== slySection) {
      slyWrapper.style.display = 'none';
    }
  }
  return;
}

  // Non coin-size patch: hide stageContainer + its wrapper, show SLY
  const stageContainer = document.getElementById('stageContainer');
  if (stageContainer) {
    stageContainer.style.display = 'none';
    const stageWrapper =
      stageContainer.closest('section, .custome-stage-wrapper, .stage-wrapper, .shopify-section') ||
      stageContainer.parentElement;
    if (stageWrapper) {
      stageWrapper.style.display = 'none';
    }
  }

  if (slySection) {
    slySection.classList.remove('d-none');
    slySection.style.display = '';
  }

  bindSlyCta();
  prefetchSeemaStory();
}

function bindSlyCta() {
  const cta = document.querySelector('[data-someone-like-you-cta]');
  if (!cta || cta.dataset.bound === 'true') return;
  cta.dataset.bound = 'true';

  cta.addEventListener('mouseenter', prefetchSeemaStory, { once: true });
  cta.addEventListener('touchstart', prefetchSeemaStory, { once: true, passive: true });

  cta.addEventListener('click', (e) => {
    e.preventDefault();
    fireSomeoneLikeYouClick();
    openSeemaStorySheet();
  });
}

function fireSomeoneLikeYouClick() {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      eventName: "someone_like_you_story_click",
      eventAttributes: {
        generalAttributes: {
          platform: "web_shopify",
          domain: "traya.health",
          cta: "Read full story",
          syntheticId: window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      caseId: caseId
    })
  });
}

function openSeemaStorySheet() {
  const sheet = document.getElementById('seema-story-sheet') || buildSeemaStorySheet();
  const contentEl = sheet.querySelector('.seema-sheet__content');

  const renderContent = (node) => {
    contentEl.innerHTML = '';
    contentEl.appendChild(node.cloneNode(true));

    contentEl.querySelectorAll('script').forEach(oldScript => {
      const newScript = document.createElement('script');
      [...oldScript.attributes].forEach(a => newScript.setAttribute(a.name, a.value));
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  };

  if (!contentEl.dataset.loaded) {
    if (seemaStoryCache) {
      // Cache hit → render synchronously, content shows with the slide-up
      renderContent(seemaStoryCache);
      contentEl.dataset.loaded = 'true';
    } else {
      // Cache miss → kick off fetch, render when ready
      contentEl.innerHTML = '';
      prefetchSeemaStory()
        .then(node => {
          renderContent(node);
          contentEl.dataset.loaded = 'true';
        })
        .catch(() => {
          contentEl.innerHTML = '<div class="seema-sheet__error">Couldn\'t load the story. Please try again.</div>';
        });
    }
  }

  // Force a paint between insert and is-open so the slide-up transition runs
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      sheet.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });
}

function closeSeemaStorySheet() {
  const sheet = document.getElementById('seema-story-sheet');
  if (!sheet) return;

  stopMediaInSheet(sheet);

  sheet.classList.remove('is-open');
  document.body.style.overflow = '';
}

function stopMediaInSheet(container) {
  container.querySelectorAll('video').forEach(video => {
    try {
      video.pause();
      video.currentTime = 0;
    } catch (e) {}
  });

  container.querySelectorAll('iframe').forEach(iframe => {
    if (iframe.src && iframe.src !== 'about:blank') {
      if (!iframe.dataset.src) {
        iframe.dataset.src = iframe.src;
      }
      iframe.src = 'about:blank';
    }
  });

  container.querySelectorAll('.js-watch-story-player').forEach(p => p.hidden = true);
  container.querySelectorAll('.js-watch-story-trigger').forEach(t => t.style.display = '');
}

function buildSeemaStorySheet() {
  // Guard against duplicate builds
  const existing = document.getElementById('seema-story-sheet');
  if (existing) return existing;

  const sheet = document.createElement('div');
  sheet.id = 'seema-story-sheet';
  sheet.className = 'seema-sheet';
sheet.innerHTML = `
    <div class="seema-sheet__overlay" data-sheet-close></div>
    <div class="seema-sheet__panel" role="dialog" aria-modal="true" aria-label="Seema's story">
      <div class="seema-sheet__handle" aria-hidden="true"></div>
      <button type="button" class="seema-sheet__close" aria-label="Close" data-sheet-close>
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#262626" stroke-width="2" stroke-linecap="round">
          <path d="M6 6 L18 18 M18 6 L6 18"/>
        </svg>
      </button>
      <div class="seema-sheet__content"></div>
    </div>
  `;
  document.body.appendChild(sheet);

  // Event delegation on the sheet itself — survives re-renders, fires once
  sheet.addEventListener('click', (e) => {
    if (e.target.closest('[data-sheet-close]')) {
      closeSeemaStorySheet();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sheet.classList.contains('is-open')) {
      closeSeemaStorySheet();
    }
  });

  return sheet;
}